import React, { ChangeEvent, useEffect, useState } from "react";

import Typography from "@mui/material/Typography";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Switch,
  Tab,
  TextField,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import AutoCompleteMultiSelect from "../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import TextAreaComponents from "../../components/TextAreaComponents/TextAreaComponents.tsx";
import galleryIcon from "./../../../assets/icons/gallery.png";
import plusIcon from "./../../../assets/icons/plus.png";
import "./AddItem.css";
import { Delete, FlashAuto } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import StickyHeadTable from "../../components/SpecificationTable/Specification.tsx";
import Details from "./../../product/components/Details.tsx";
import Story from "./../../product/components/Story.tsx";
import Instructions from "./../../product/components/Instructions.tsx";
import Cancel from "./../../../assets/icons/close.png";
import AddSectionDialog from "./AddSectionDialog.tsx";
import AddSubFilterDialog from "./AddSubFilter/AddSubFilterDialog.tsx";
import AddSpecification from "./AddSpecifications/AddSpecification.tsx";
import KeywordDialog from "./KeywordDialog.tsx";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import ImportSpecification from "./ImportSpecification/ImportSpecification.tsx";
import TimingComponenet from "../../components/TimingComponenet/TimingComponenet.tsx";
import SweetAlertModal from "../../../pages/components/SweetAlertModal/SweetAlertModal.js";
import ArrowUpIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownIcon from "@mui/icons-material/ArrowDownward";

import Stack from "@mui/material/Stack";

import { option } from "yargs";
import ChickenIcon from "./../../../assets/icons/turkey.png";
import ChickenLegIcon from "./../../../assets/icons/chicken-leg.png";
import Burger1Icon from "./../../../assets/icons/burger1.png";
import Burger2Icon from "./../../../assets/icons/burger.png";
import FullPizzaIcon from "./../../../assets/icons/pizza.png";
import pizzaIcon from "./../../../assets/icons/pizza (1).png";
import previewImg from "./../../../assets/icons/preview.png";
import itemImg from "./../../../assets/icons/Item.png";
import importImg from "./../../../assets/icons/import.png";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Chip from "@mui/material/Chip";

import SchedulerView from "./../components/SchedulerView/SchedulerView.tsx";
import CreateNewSchedule from "./SchedulerView/ScheduleItemDialog/CreateNewSchedule/CreateNewSchedule.tsx";
import SchedulerComponent from "./SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx";
import ImportItemView from "./ImportItemView/ImportItemView.tsx";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";

import Collapse from "@mui/material/Collapse";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import axios from "axios";
import { getAPI } from "./../../../api/Common.js";
import { uploadOneFiles } from "./../../../fileUploader/SingleFileUploader.js";
import { ToastContainer, toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import { cleanLeadingZeros } from "@mui/x-date-pickers/internals/hooks/useField/useField.utils.js";
import LoadingView from "../../components/LoadingView/LoadingView.js";
import AddMenuDialog from "./AddMenuDialog.tsx";
import EditRankDialog from "./EditRankDialog/EditRankDialog.tsx";
import Kitchens from "./Kitchens/Kitchens.tsx";
import VatSetupDialog from "../../restaurantsetup/components/VATSetupDialog/VATSetupDialog.tsx";
import AddItemSchedulerDialog from "./AddItemSchedulerDialog.tsx";
import { tr } from "date-fns/locale";
interface ImageUploadState {
  // selectedImage: string | null
  selectedImages: string[];
}

function AddItemDialogComponent(props) {
  const [RestaurantErr, setRestaurantErr] = useState(false);
  const [MainsectionErr, setMainsectionErr] = useState(false);
  const [SectionErr, setSectionErr] = useState(false);
  const [SubSectionErr, setSubSectionErr] = useState(false);
  const [ItemNameErr, setItemNameErr] = useState(false);
  const [DescriptionErr, setDescriptionErr] = useState(false);
  const [ImageErr, setImageErr] = useState(false);
  const [KeywordErr, setKeywordErr] = useState(false);
  const [KeywordTagsErr, setKeywordTagsErr] = useState(false);
  const [PriceErr, setPriceErr] = useState(false);
  const [VatErr, setVatErr] = useState(false);
  const [AddonsErr, setAddonsErr] = useState(false);
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);
  const [openAddVat, setopenAddVat] = useState(false);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);

  const [loadingModal, SetloadingModal] = React.useState(false);

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  const [value, setValue] = React.useState("1");
  const [switchCheck, setswitchCheck] = useState(false);
  const [defaultvalue, setDefaultvalue] = useState({});
  // const { title } = props.title
  //Addsection dialog control start
  const [openAddKeyword, setOpenAddKeyword] = useState(false);

  const [openAddSection, setOpenAddSection] = useState(false);
  const [openAddSubSection, setOpenAddSubSection] = useState(false);

  // const [openSchedule, setSchedule] = useState(false);
  const [dialogType, setDialogType] = useState("");

  const handleClickOpen = () => {
    setOpenAddSection(true);
    setDialogType("Add Section");
  };

  const handleClickOpenOk = () => {
    setOpenAddSubSection(true);
    setDialogType("Add Sub Filter from addItem");
  };
  const handleClickKeyword = () => {
    setOpenAddKeyword(true);
  };
  const handleAddItem = (shouldReloadSections = false) => {
    setOpenAddSection(false);
    setOpenAddSubSection(false);
    setopenAddVat(false);
    setOpenMenu(false);

    if (shouldReloadSections && selectedMenuDatas.length > 0) {
      loadSectionData(selectedMenuDatas);
    }
  };

  const handleKeywordDialog = (KeywordDialog) => {
    setOpenAddKeyword(KeywordDialog);
  };
  //AddSpecification modal open functionality
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCloseSpecifications = () => {
    setOpen(false);
  };
  //Addsection dialog controll end
  const [openImportSpecification, setopenImportSpecification] = useState(false);
  //image upload code start
  const handleopenImportSpecification = () => {
    setopenImportSpecification(true);
  };

  const handleCloseImportSpecification = () => {
    setOpen(false);
  };
  const [state, setState] = useState<ImageUploadState>({
    selectedImages: [],
  });
  const [imageFile, setImageFile] = useState([]);
  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 5 - state.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);

      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        setImageFile((prevItems) => [...prevItems, file]);

        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [...state.selectedImages, ...imagesArray];
            setState({ selectedImages: updatedImages });
          }
        };
        reader.readAsDataURL(file);
      }
    }
    setImageErr(false);
  };

  const handleDeleteImage = (index: number) => {
    const updatedImages = [...state.selectedImages];
    const updateImageFile = [...imageFile];
    updatedImages.splice(index, 1);
    updateImageFile.splice(index, 1);
    setImageFile(updateImageFile);
    setState({ selectedImages: updatedImages });
  };

  //image upload code end

  const handleSwitchChange = () => {
    setswitchCheck(!switchCheck);
    setSelectedSubSectionValue([]);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const handleClose = () => {
    //props.onHandleAddItem(false);
    setopenConfirmaitonModal(true);
  };

  const handleAddDialogClose = () => {
    props.onHandleAddItem(false);
    //setKeyword(null)
    setopenConfirmaitonModal(false);
  };

  useEffect(() => {
    try {
      // 1. Get the string from local storage
      const storedRestaurant = localStorage.getItem("restaurant");

      // 2. Parse it if it exists
      if (storedRestaurant) {
        const parsedData = JSON.parse(storedRestaurant);

        // 3. Update state
        setSelectedRestaurant(parsedData);

        // Optional: If you need this for other API calls later,
        // you might also want to update your existing 'restaurantArray' or similar states here
        // setRestaurantArray([parsedData.id]);
      }
    } catch (error) {
      console.error("Error parsing restaurant from localStorage:", error);
      // Handle error gracefully (e.g., set to null or show a toast)
      setSelectedRestaurant(null);
    }
  }, []); // Empty dependency array ensures this runs only once on mount

  const onHandleAddItem = () => {};
  const [autoCompleteValue, setAutoCompleteValue] = React.useState([]);
  const [specificationRows, setSpecificationRows] = React.useState([]);
  const handleAddSpecification = (newSpecification) => {
    // Add the new specification to the existing rows data
    setSpecificationRows((prevRows) => [...prevRows, newSpecification]);
  };
  const apiAddress = process.env.REACT_APP_SECRET;
  const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));
  const RestauranttokenLocal = JSON.parse(localStorage.getItem("restaurant"));

  const [restaurantDatas, setRestaurantDatas] = React.useState([]);

  const token = localStorage.getItem("gotasteadmintoken");
  const [userId, setUserId] = useState();

  const loadRestaurantName = () => {
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) {}
    }
    if (decodedData.UserId) {
      axios
        .get(
          apiAddress +
            `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`,
        )
        .then((response) => {
          var list = [];
          response.data.map((dt, i) => {
            var obj = {
              id: dt.restaurantId,
              title: dt.restaurantName,
            };
            list.push(obj);
          });
          setRestaurantDatas(list);
        });
    }
  };

  const [addOnDatas, setAddons] = useState([]);
  const [restaurantAdded, setRestaurantAdded] = useState([]);

  const loadAddons = async (restaurant) => {
    await axios
      .post(
        apiAddress + "/api/AddOns/GetAddOnsMasterByRestaurantIdList",
        restaurant,
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            title: dt.isCountable
              ? `${dt.addOnName} | Countable`
              : dt.addOnName,
            img: dt.logoUrl,
            restaurantName: dt.restaurantName,
            restaurantId: restaurant.id,
            isCountable: dt.isCountable, // Include isCountable property
          };
          list.push(obj);
        });
        setAddons(list);
      });
  };

  const [keywordDatas, setkeywordDatas] = React.useState([]);

  async function keyworddataByRestaurantId() {
    var list = [];
    var response = await axios.post(
      apiAddress + "/api/Keyword/getkeywordbyrestaurantwithlist",
      restaurantDatas,
    );
    list.push(response.data);

    return list;
  }

  const loadKeyword = async () => {
    var list = await keyworddataByRestaurantId();
    var KeywordList = [];

    list[0].map((d, i) => {
      var obj = { id: d.id, title: d.keywordName };
      KeywordList.push(obj);
    });
    setkeywordDatas(KeywordList);
  };
  const [Menudata, setMenuData] = useState([]);
  const [allMenuData, setAllMenuData] = useState([]);

  const [Sectiondata, setSectiondata] = useState([]);
  const [allSectiondata, setallSectiondata] = useState([]);

  const [selectedRestaurantDatas, setSelectedRestaurantDatas] = useState([]);
  const [selectedMenuDatas, setSelectedMenuDatas] = useState([]);
  const [selectedSectionDatas, setSelectedSectionDatas] = useState([]);
  const [restaurantArray, setRestaurantArray] = useState<string[]>([]);
  const [sectionArray, setSectionArray] = useState<string[]>([]);

  const handleRemoveData = (restaurant) => {
    const updatedRestaurants = selectedRestaurantDatas.filter(
      (r) => r.id !== restaurant.id,
    );
    setSelectedRestaurantDatas(updatedRestaurants);

    // Remove associated menus
    const updatedMenus = selectedMenuDatas.filter(
      (menu) => menu.restaurantId !== restaurant.id,
    );
    setSelectedMenuDatas(updatedMenus);

    const updatedSections = selectedSectionDatas.filter(
      (section) => section.restaurantId !== restaurant.id,
    );
    setSelectedSectionDatas(updatedSections);
    setRestaurantArray(
      updatedRestaurants.map((updatedRestaurant) => updatedRestaurant.id),
    );
    setSectionArray(updatedSections.map((updatedSection) => updatedSection.id));
  };

  const handleMenuChange = (menu) => {
    const updatedSections = selectedSectionDatas.filter(
      (section) => section.menuId !== menu.id,
    );
    setSelectedSectionDatas(updatedSections);
  };

  type Restaurant = {
    id: string;
    title: string;
  };

  const handleRestaurantChange = (restaurant: Restaurant) => {
    const updatedArray = [...restaurantArray, restaurant.id];
    setRestaurantArray(updatedArray);
  };

  type Section = {
    id: string;
    title: string;
    img: string;
    menuId: string;
    restaurantId: string;
    restaurantName: string;
  };

  const [sectionTitles, setSectionTitles] = useState<Record<string, string>>(
    {},
  );

  console.log("selectedSectionDatas", selectedSectionDatas);

  // const handleSectionChange = (sections: Section[]) => {
  //   // Extract section IDs and titles
  //   const sectionIds = sections.map((section) => section.id);
  //   const titlesMap = sections.reduce((acc, section) => {
  //     acc[section.id] = section.title;
  //     return acc;
  //   }, {} as Record<string, string>);

  //   // Update section states
  //   setSectionStates((prev) => {
  //     const updatedState = { ...prev };
  //     sectionIds.forEach((id) => {
  //       if (!updatedState[id]) {
  //         updatedState[id] = { isDeliverable: false, isCollection: false };
  //       }
  //     });
  //     return updatedState;
  //   });

  //   // Update section titles
  //   setSectionTitles((prev) => ({ ...prev, ...titlesMap }));

  //   // Store only section IDs
  //   setSectionArray(sectionIds);
  // };

  const handleSectionChange = (sections: Section[]) => {
    // Extract section IDs and titles
    console.log("sections", sections);
    const sectionIds = sections.map((section) => section.id);
    const titlesMap = sections.reduce(
      (acc, section) => {
        const menu = selectedMenuDatas.find((m) => m.id === section.menuId);
        acc[section.id] = {
          title: section.title,
          isRestaurantCollectionOnly: menu?.isRestaurantCollectionOnly || false,
        };
        return acc;
      },
      {} as Record<
        string,
        { title: string; isRestaurantCollectionOnly: boolean }
      >,
    );
    console.log("titlesMap", titlesMap);
    console.log("sectionIds", sectionIds);
    // Update section states
    setSectionStates((prev) => {
      const updatedState = { ...prev };
      sectionIds.forEach((id) => {
        if (!updatedState[id]) {
          updatedState[id] = {
            isDeliverable: true,
            isCollection: titlesMap[id].isRestaurantCollectionOnly, // Set initial value based on flag
          };
        }
      });
      return updatedState;
    });

    // Store section titles and flags
    setSectionTitles(titlesMap);
    setSectionArray(sectionIds);
  };

  const [kitchens, setKitchens] = useState<string[]>([]);
  const [getkitchens, setgetkitchens] = useState<string[]>([]);

  const getkitchensFnc = (props) => {
    setgetkitchens(props);
    // Schedule.push(props)
  };

  useEffect(() => {
    const getKitchenData = async () => {
      try {
        if (restaurantArray.length > 0 && sectionArray.length > 0) {
          const response = await axios.post(
            `${apiAddress}/api/FoodItems/GetResturentSectionKitchenAsync`,
            {
              restaurantIds: restaurantArray,
              sectionIds: sectionArray,
            },
          );
          setKitchens(response.data);
        }
      } catch (error) {}
    };

    getKitchenData();

    if (restaurantArray.length <= 0 || sectionArray.length <= 0) {
      setKitchens([]);
    }
  }, [restaurantArray, sectionArray]);

  const loadMenuData = async (props) => {
    var list = [];
    var Alllist = [];
    props.map(async (d, i) => {
      const response = await axios.get(apiAddress + "/api/Menu/" + d.id);
      response.data.map((dt, i) => {
        var obj = {
          id: dt.menuId,
          title: dt.menuName,
          img: dt.logoUrl,
          restaurantName: dt.restaurantName,
          restaurantId: d.id,
          menuTypeName: dt.menuTypeName,
          isRestaurantCollectionOnly: dt.isRestaurantCollectionOnly,
          isCollectionOnly: dt.isCollectionOnly,
        };
        list.push(obj);
        dt.MenuRestaurantMapperLists = [];
        Alllist.push(dt);
      });
      // Alllist = response.data;
      setMenuData(list);
    });
    setAllMenuData(Alllist);
  };

  const [keywordTagdata, setKeywordTag] = useState([]);

  const loadKeywordTags = () => {
    axios.get(apiAddress + "/api/Keyword/GetALlKeywordTag").then((response) => {
      var list = [];
      response.data.map((dt, i) => {
        var obj = { id: dt.id, title: dt.keywordTagName };
        list.push(obj);
      });
      setKeywordTag(list);
    });
  };

  const [KeywordVal, setKeywordVal] = useState([]);
  const KeywordaddValue = (props) => {
    // setAutoCompleteValue(props)
    // setKeywordVal(props);
  };
  const RestaurantNames = restaurantAdded.map((item) => item.title);

  const addScheduleValue = (props) => {
    // setAutoCompleteValue(props)
  };

  const textFieldValue = (props) => {
    setAutoCompleteValue(props);
    // setselectedItemValue(props);
  };

  const [netWeightVal, setnetWeightVal] = useState();
  const netWeightValue = (props) => {
    setnetWeightVal(props);
    // setselectedItemValue(props);
  };
  const [selectedItemValue, setselectedItemValue] = useState();
  const nameValue = (props) => {
    setselectedItemValue(props);
    setItemNameErr(false);
  };

  const [descirptionVal, setdescirptionVal] = useState();
  const descirptionValue = (props) => {
    setdescirptionVal(props);
    setDescriptionErr(false);
  };
  const [priceExclusive, setPriceExclusive] = useState("");
  const [minimumOrderSize, setminimumOrderSize] = useState();
  const [maximumOrderSize, setmaximumOrderSize] = useState();
  const [priceInclusive, setpriceInclusive] = useState("");
  const [hasInclusiveValue, setHasInclusiveValue] = useState(false);

  const [minimumIncreamentSize, setminimumIncreamentSize] = useState();
  const setpriceExclusiveval = (props) => {
    //const val = Number(props) || '';
    setPriceExclusive(props);
    //setPriceExclusive(val);
    setPriceErr(false);
  };
  // const AddMinimumOrderValue = (props) => {
  //   setminimumOrderSize(props);

  // };
  const AddMinimumOrderValue = (props) => {
    const value = props === "" ? 0 : Number(props);
    setminimumOrderSize(value);
  };
  const AddMaximumOrderValue = (props) => {
    setmaximumOrderSize(props);
  };
  const AddMinimumIncreamentValue = (props) => {
    setminimumIncreamentSize(props);
  };

  const [vatAmount, setVatAmount] = useState(0);
  const [vatInAmount, setvatInAmount] = useState(0);

  const inAmountVATValue = (props) => {
    const amt = Number(props) || 0;
    setVatAmount(Number(amt.toFixed(2)));
    const pe = Number(priceExclusive) || 0;
    if (pe > 0) {
      const percent = (amt * 100) / pe;
      setvatInAmount(Number(percent.toFixed(2)));
    } else {
      setvatInAmount(0);
    }
    setpriceInclusive(Number((pe + amt).toFixed(2)));
  };

  const inPercentageVATValue = (props) => {
    const percent = Number(props) || 0;
    const pe = Number(priceExclusive) || 0;
    const total = (percent / 100) * pe;
    setVatAmount(Number(total.toFixed(2)));
    setvatInAmount(Number(percent.toFixed(2)));
    setpriceInclusive(Number((pe + total).toFixed(2)));
    setVatErr(false);
  };

  const [isactive, setIsactive] = React.useState(false);

  const handleimportedDatas = () => {
    setopenImportSpecification(false);
  };
  const [quantity, setquantity] = React.useState(0);
  const selectedData = (props) => {};
  //Section icon show start
  const [selectedValue, setSelectedValue] = useState([]);

  const [imageMap, setimageMap] = useState([]);

  const [menuid, setMenuId] = useState();

  const loadSectionData = async (props) => {
    let sections = [];
    let Allsections = [];
    props.map(async (d, i) => {
      const response = await axios.get(
        apiAddress + "/api/Section/getallsectionbasedonmenuid?id=" + d.id,
      );
      response.data.map((dt, i) => {
        let sectionNew = {
          id: dt.id,
          title: dt.keywordName,
          img: dt.iconUrl,
          menuId: d.id,
          restaurantId: d.restaurantId,
          restaurantName: d.title,
          menuTypeName: d.menuTypeName,
        };
        sections.push(sectionNew);

        Allsections.push(dt);
      });
      // Alllist = response.data;
    });
    setallSectiondata(Allsections);
    setSectiondata(sections);
  };

  const [subSectionImage, setSubsectionImage] = useState([]);

  useEffect(() => {
    if (switchCheck == true) {
      axios
        .get(apiAddress + "/api/SubSection/GetAllSubFilter")
        .then((response) => {
          var list = [];
          response.data.map((dt, i) => {
            var obj = {
              id: dt.id,
              title: dt.subFilterName,
              img: dt.iconUrl,
            };
            list.push(obj);
          });
          setSubsectionImage(list);
        });
    }
  }, [switchCheck]);

  const handleImportItem = (props) => {
    // let val = Menudata.find(x => x.title === props.section);
    var index = Menudata.findIndex((x) => x.title === props.section);

    setDefaultvalue(Menudata[index]);

    setOpenImport(false);

    // section
    var arr = [];
    arr.push(imageMap[1]);
    arr.push(imageMap[5]);
    //setSelectedValue(arr);
    // sub section
    setswitchCheck(true);
    var arr2 = [];
    arr2.push(imageSectionMap[2]);
    arr2.push(imageSectionMap[4]);
    setSelectedSectionValue(arr2);

    // item
    setselectedItemValue("");
    setselectedItemValue(props.item);

    // description

    setdescirptionVal(
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unkown printer took a galley of type",
    );

    // keywords
    var arr3 = [];
    arr3.push(keywordDatas[2]);
    arr3.push(keywordDatas[4]);
    setKeywordVal(arr3);

    // price exclusive
    setPriceExclusive(1200);

    // vat
    setvatInAmount(10);
    var Vatprice = 10 * 100;
    var total = Vatprice / priceExclusive;
    setvatInAmount(total);
    setVatAmount(10);
    //setpriceInclusive(parseFloat(priceExclusive) + parseFloat(total));

    // net weight
    setnetWeightVal(10);
  };

  //Section icon show end

  const [selectedSubSectionValue, setSelectedSubSectionValue] = useState([]);
  const handleAutocompleteSectionChange = (
    event: ChangeEvent<{}>,
    value: any,
  ) => {
    setSelectedSectionValue(value);

    setSubSectionErr(false);
  };

  //sub section icon show end

  // Stepper Start
  const steps = ["Add Item", "Create Schedule"];
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());

  const isStepOptional = (step: number) => {
    return step === 1;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    if (!selectedSectionDatas || selectedSectionDatas.length === 0) {
      toast.error("Please select a section.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const [options, setOptions] = React.useState(props.datas);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent the default Enter key action

      let restaurantIds = [];

      selectedRestaurantDatas.map((dt, i) => {
        restaurantIds.push(dt?.id);
      });

      const inputValue = event.target.value.trim();
      if (
        inputValue &&
        !keywordDatas.some((option) => option.title === inputValue)
      ) {
        // Add the new value to the array
        var obj = {
          id: "string",
          keywordName: inputValue,
          restaurantId: RestauranttokenLocal.id,
          isActive: true,
          creatorId: "string",
          creationDate: "2023-08-21T06:38:08.240Z",
          modifierId: "string",
          modificationDate: "2023-08-21T06:38:08.240Z",
          restaurantIds: restaurantIds,
        };
        var url = apiAddress + "/api/Keyword";

        axios.post(url, obj).then((response) => {
          var list = [];
          var obj = {
            Id: "123",
            FoodItemId: "123",
            KeywordId: response.data.id,
            CreationId: "123",
            Status: "Add",
          };
          list.push(obj);
          //setkeywordObjlist(list)
          setkeywordObjlist([...keywordObjlist, obj]);

          setkeywordDatas((prev) => [
            ...prev,
            { id: response.data.id, title: inputValue },
          ]);
        });
      }

      // Clear the input field
      event.target.value = "";
    }
  };
  // Stepper End
  const [openImport, setOpenImport] = React.useState(false);

  //tooltip start
  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 320,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }));

  function createData(
    AddonName,
    IsToggle,
    buttonStyle,
    maxSelection,
    option,
    isCountableLinked: boolean,
    isMandatory: boolean,
    isCountable: boolean,
  ) {
    return {
      AddonName,
      IsToggle,
      buttonStyle,
      maxSelection,
      option: option.map((opt) => ({
        ...opt,
        isLinked: false, // Default value for "Link with fooditem"
        isMandatory: false, // Default value for "Mandatory"
      })),
      isCountableLinked,
      isMandatory,
      isCountable,
      isOptionMustPick: false,
    };
  }

  const [maxVal, setMaxVal] = React.useState(0);

  const moveUp = (index) => {
    if (index === 0) return; // Can't move the first row up
    const newRows = [...rowsData];
    [newRows[index - 1], newRows[index]] = [newRows[index], newRows[index - 1]];
    // Update serial numbers
    newRows[index - 1].rank -= 1;
    newRows[index].rank += 1;
    setRowsData(newRows);
  };

  const moveDown = (index) => {
    if (index === rowsData.length - 1) return; // Can't move the last row down
    const newRows = [...rowsData];
    [newRows[index], newRows[index + 1]] = [newRows[index + 1], newRows[index]];
  };

  function Row(props: {
    row: ReturnType<typeof createData>;
    idx: number;
    onToggle: (index: number) => void;
    onMandatoryToggle: (index: number) => void;
  }) {
    const { row, idx, onToggle, onMandatoryToggle } = props;
    const [open, setOpen] = React.useState(true);

    const handleToggleLinked = (optionId) => {
      setRowsData((prevRows) =>
        prevRows.map((r, i) => {
          if (i !== idx) return r;

          const updatedOptions = r.option.map((opt) => {
            if (opt.addOnOptionsMaster.id === optionId) {
              return { ...opt, isLinked: !opt.isLinked };
            }
            return opt;
          });

          return {
            ...r,
            option: updatedOptions,
            isCountableLinked: updatedOptions.every((opt) => opt.isLinked),
          };
        }),
      );
    };

    const handleToggleMandatory = (optionId, isMandatory) => {
      setRowsData((prevRows) =>
        prevRows.map((r, i) => {
          if (i !== idx) return r;

          const updatedOptions = r.option.map((opt) => {
            if (opt.addOnOptionsMaster.id === optionId) {
              return { ...opt, isMandatory: !opt.isMandatory };
            }
            return opt;
          });

          return {
            ...r,
            option: updatedOptions,
            isMandatory: updatedOptions.some((opt) => opt.isMandatory),
          };
        }),
      );
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell></TableCell>
          <TableCell>
            <IconButton size="small" onClick={() => moveUp(idx)}>
              <ArrowUpIcon sx={{ width: "1.2rem", height: "1.2rem" }} />
            </IconButton>
            <span>{row.rank}</span>
            <IconButton size="small" onClick={() => moveDown(idx)}>
              <ArrowDownIcon sx={{ width: "1.2rem", height: "1.2rem" }} />
            </IconButton>
          </TableCell>
          <TableCell>
            {row.isCountable ? `${row.AddonName} | Countable` : row.AddonName}
          </TableCell>
          <TableCell align="right">{row.IsToggle}</TableCell>
          <TableCell align="right">{row.buttonStyle}</TableCell>
          <TableCell align="right">{row.maxSelection}</TableCell>
          <TableCell align="center">
            <Tooltip
              title={
                row.isCountable
                  ? "For countable addons, all options are automatically linked when enabled"
                  : "Link all options with food item"
              }
            >
              <Switch
                checked={row.isCountableLinked}
                onChange={() => onToggle(idx)}
              />
            </Tooltip>
          </TableCell>
          <TableCell align="center">
            <Switch
              checked={row.isMandatory}
              onChange={() => onMandatoryToggle(idx)}
              disabled={isMustPick}
            />
          </TableCell>
        </TableRow>
        <TableRow>
          {row.option.length > 0 ? (
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Typography variant="h6" gutterBottom component="div">
                    Option
                  </Typography>
                  <TableContainer component={Paper}>
                    <Table aria-label="collapsible table">
                      <TableHead>
                        <TableRow>
                          <TableCell />
                          <TableCell>
                            Must Pick
                            <span> </span>
                            <Switch
                              checked={row.isOptionMustPick}
                              onChange={() => handleOptionMustPick(idx)}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>Option Name</TableCell>
                          <TableCell align="right">Base Price</TableCell>
                          <TableCell align="right">Vat</TableCell>
                          <TableCell align="right">Inclusive Price</TableCell>
                          <TableCell>Link with fooditem</TableCell>
                          <TableCell>Mandatory</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row.option.map((optionRow) => (
                          <OptionRow
                            key={optionRow.addOnOptionsMaster.id}
                            row={optionRow}
                            onToggleLinked={handleToggleLinked}
                            onToggleMandatory={handleToggleMandatory}
                            isCountableAddon={row.isCountable}
                            isOptionMustPickfromAddon={row.isOptionMustPick}
                          />
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Collapse>
            </TableCell>
          ) : (
            ""
          )}
        </TableRow>
      </React.Fragment>
    );
  }
  const [isMustPick, setisMustPick] = React.useState(false);

  const handleMustPick = () => {
    if (isMustPick == false) {
      setisMustPick(true);

      setRowsData((prevRows) =>
        prevRows.map((row) => ({
          ...row,
          isMandatory: false,
        })),
      );
    } else if (isMustPick == true) {
      setisMustPick(false);
    }
  };

  const [isOptionMustPick, setisOptionMustPick] = React.useState(false);

  const handleOptionMustPick = (rowIndex) => {
    setRowsData((prevRows) =>
      prevRows.map((r, i) => {
        if (i === rowIndex) {
          const newIsOptionMustPick = !r.isOptionMustPick;

          return {
            ...r,
            isOptionMustPick: newIsOptionMustPick,
            option: newIsOptionMustPick
              ? r.option.map((opt) => ({ ...opt, isMandatory: false }))
              : r.option,
          };
        }
        return r;
      }),
    );
  };

  const OptionRow = React.memo((props) => {
    const {
      row,
      onToggleLinked,
      onToggleMandatory,
      isCountableAddon,
      isOptionMustPickfromAddon,
    } = props;
    const [open, setOpen] = React.useState(false);
    const [isLinked, setIsLinked] = React.useState(row.isLinked);
    const [isMandatory, setIsMandatory] = React.useState(row.isMandatory);

    const handleLinkedToggle = () => {
      if (isCountableAddon) {
        return;
      }
      const newIsLinked = !isLinked;
      setIsLinked(newIsLinked);
      onToggleLinked(row.addOnOptionsMaster.id, newIsLinked);
    };

    const handleMandatoryToggle = () => {
      const newIsMandatory = !isMandatory;
      setIsMandatory(newIsMandatory);
      onToggleMandatory(row.addOnOptionsMaster.id, newIsMandatory);
    };

    React.useEffect(() => {
      setIsLinked(row.isLinked);
    }, [row.isLinked]);

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell></TableCell>
          <TableCell component="th" scope="row">
            {row.addOnOptionsMaster.optionName}
            {row.isCountable && (
              <span
                style={{
                  float: "right",
                  color: "#1976d2",
                  fontWeight: 500,
                  fontSize: "0.95em",
                  marginLeft: 8,
                }}
              >
                | Countable
              </span>
            )}
          </TableCell>
          <TableCell align="right">
            {row.addOnOptionsMaster.basePrice}
          </TableCell>
          <TableCell align="right">
            {row.addOnOptionsMaster.vaTinPercentage}
          </TableCell>
          <TableCell align="right">{row.inclusivePrice}</TableCell>
          <TableCell align="center">
            <Tooltip
              title={
                isCountableAddon
                  ? "Individual option linking is disabled for countable addons"
                  : "Link this option with food item"
              }
            >
              <Switch
                checked={isLinked}
                onChange={handleLinkedToggle}
                disabled={isCountableAddon}
              />
            </Tooltip>
          </TableCell>
          <TableCell align="center">
            <Switch
              checked={isMandatory}
              onChange={handleMandatoryToggle}
              disabled={isOptionMustPickfromAddon}
            />
          </TableCell>
        </TableRow>
        <TableRow>
          {row.addOnSubOptionsMasterList.length > 0 ? (
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Typography variant="h6" gutterBottom component="div">
                    Sub-Option
                  </Typography>
                  <TableContainer component={Paper}>
                    <Table aria-label="collapsible table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Sub Option Name</TableCell>
                          <TableCell align="right">Price</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row.addOnSubOptionsMasterList.map((subOptionRow) => (
                          <SubOptionRow
                            key={subOptionRow.subOptionName}
                            row={subOptionRow}
                          />
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Collapse>
            </TableCell>
          ) : (
            ""
          )}
        </TableRow>
      </React.Fragment>
    );
  });

  function SubOptionRow(props) {
    const { row } = props;
    // const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell component="th" scope="row">
            {/* {row.suboptionName} */}
            {row.subOptionName}
          </TableCell>
          <TableCell align="right">
            {/* {row.subBaseprice} */}
            {row.price}
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const [tempRowsData, setTempRowsData] = useState([]);
  const [addonsData, setAddonData] = useState([]);
  const loadAddonOptionListSuboptionList = async (addonId) => {
    var dataList = [];
    await Promise.all(
      addonId.map(async (d, i) => {
        try {
          const response = await axios.get(
            apiAddress +
              "/api/AddOns/GetAddOnsOptionSuboptionByAddonId?addonId=" +
              d.id,
          );
          const data = createData(
            response.data.addOnsMaster.addOnName,
            response.data.addOnsMaster.isCollapsibleOption ? "true" : "N/A",
            response.data.addOnsMaster.optionButtonId == 3
              ? "Radio button"
              : response.data.addOnsMaster.optionButtonId == 4
                ? "Check Box"
                : response.data.addOnsMaster.optionButtonId == 5
                  ? "Button"
                  : response.data.addOnsMaster.optionButtonId == 6
                    ? "TextBox"
                    : "N/A",
            response.data.addOnsMaster.maxSelection
              ? response.data.addOnsMaster.maxSelection
              : "N/A",
            response.data.addOnOptionFormViews,
            d.isCountableLinked,
            d.isMandatory,
            response.data.addOnsMaster.isCountable, // Add isCountable property
          );

          dataList.push(data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }),
    );

    //setRowsData(dataList);
    setTempRowsData(dataList);
  };
  const [rowsData, setRowsData] = useState(
    tempRowsData.map((row) => ({
      ...row,
      isCountableLinked: false,
      isMandatory: false,
      isCountable: row.isCountable || false,
      option: row.option.map((opt) => ({
        ...opt,
        isLinked: false,
        isMandatory: false,
      })),
    })),
  );

  const linktoggle = (index) => {
    setRowsData((prevRows) =>
      prevRows.map((row, idx) => {
        if (idx === index) {
          const newIsCountableLinked = !row.isCountableLinked;

          // For countable addons, all options must be linked when toggle is enabled
          const updatedOptions = row.option.map((opt) => ({
            ...opt,
            isLinked: newIsCountableLinked, // Set isLinked for all options
          }));

          return {
            ...row,
            isCountableLinked: newIsCountableLinked,
            option: updatedOptions,
          };
        }
        return row;
      }),
    );
  };

  const onMandatoryToggle = (index) => {
    setRowsData((prevRows) =>
      prevRows.map((row, idx) =>
        idx === index ? { ...row, isMandatory: !row.isMandatory } : row,
      ),
    );
  };

  useEffect(() => {
    const initializeSerialNumbers = (data) => {
      return data.map((item, index) => ({
        ...item,
        rank: index + 1, // Start from 1
        isCountableLinked: false,
        isMandatory: false,
        isCountable: item.isCountable || false,
        option: item.option.map((opt) => ({
          ...opt,
          isLinked: false,
          isMandatory: false,
        })),
      }));
    };
    const dataWithRanks = initializeSerialNumbers(tempRowsData);
    setRowsData(dataWithRanks);
  }, [tempRowsData]);

  const [toggles, setToggles] = useState(rowsData.map(() => false));

  const [selectedAddons, setSelectedAddons] = useState([]);

  const addonvalue = async (props) => {
    var list = [];

    await props.map(async (dt, i) => {
      const rank = rowsData.find((x) =>
        x.AddonName == dt.isCountable
          ? `${dt.addOnName} | Countable`
          : dt.addOnName,
      );

      var addonsObj = {
        id: dt.id,
        title: dt.title,
        isCountableLinked: rank?.isCountableLinked ?? false,
        isMandatory: rank?.isMandatory ?? false, // Include this field
        isCountable: dt.isCountable ?? false, // Include isCountable property
      };
      list.push(addonsObj);
    });

    await loadAddonOptionListSuboptionList(list);
    setSelectedAddons(list);
    setAddonsErr(false);
  };

  //getting details table data start
  const [details, setDetails] = useState([]);
  const getDetailsdata = (data) => {
    var list = [];
    data.map((dt, i) => {
      var obj = {
        id: "123",
        FoodItemId: "123",
        Details: dt.name,
        Description: dt.description,
        RankOrder: dt.rank,
        CreationId: "123",
      };
      list.push(obj);
    });
    setDetails(list);
  };

  //getting details table data end

  //getting instruction table data start
  const [instruction, setInstruction] = useState([]);
  const getInstructiondata = (data) => {
    var list = [];
    data.map((dt, i) => {
      var obj = {
        id: "123",
        FoodItemId: "123",
        Name: dt.name,
        Description: dt.description,
        RankOrder: dt.rank,
        CreationId: "123",
      };
      list.push(obj);
    });
    setInstruction(list);
  };

  //getting instruction table data end

  //getting story table data start
  const [story, setStory] = useState();
  const getStorydata = (data) => {
    var obj = { id: "123", FoodItemId: "123", Story: data, CreationId: "123" };
    setStory(obj);
  };

  //getting story table data end
  const [imageurl, setImageUrl] = useState([]);

  const fileUpload = async () => {
    var Url = [];
    if (imageFile.length == 0) {
      setImageErr(true);
    }
    for (let i = 0; i < imageFile.length; i++) {
      var res = await uploadOneFiles(imageFile[i]);
      var obj = {
        Id: "123",
        FoodItemId: "123",
        ItemImagePath: res[0],
        CreationId: "123",
        totalNumbersOfImage: "5",
        cropImageTypeId: "4314f388-816d-4ce0-b618-b7585b7a709e",
        Status: "Add",
      };
      Url.push(obj);
    }
    // setImageUrl(Url)
    FoodItemInsertView.FoodItemImageMapperList = Url;
  };
  const [restaurantList, setRestaurantList] = useState([]);
  const restaurantMapper = () => {
    var list = [];
    // if (restaurantAdded.length == 0) {
    //   setRestaurantErr(true);
    // }
    restaurantAdded.map((item, i) => {
      var obj = {
        Id: "123",
        FoodItemId: "123",
        RestaurantId: item.id,
        CreationId: "123",
      };
      list.push(obj);
    });
    // setRestaurantList(list)
    FoodItemInsertView.FoodItemRestaurantMapperList = list;
  };

  const [FoodItemInsertView, setFoodItemInsertView] = useState({
    FoodItems: {},
    FoodItems_2: [],
  });

  const [Schedule, setSchedule] = React.useState([]);

  //keyword start
  const [keywordObjlist, setkeywordObjlist] = useState([]);
  const [initkeywordObjlist, setinitkeywordObjlist] = useState([]);

  const handleKeywordChange = (event, newvalue) => {
    var list = [];
    newvalue.map((dt, i) => {
      keywordDatas.map((d, i) => {
        if (d.title == dt) {
          var obj = {
            Id: "123",
            FoodItemId: "123",
            KeywordId: d.id,
            CreationId: "123",
            Status: "Add",
          };
          list.push(obj);
        }
      });
    });
    setkeywordObjlist(list);
    setKeywordErr(false);
  };

  //keyword end

  //keywordTag start
  const [keywordTagList, setKeywordTagList] = useState([]);

  const addkeywordtag = (props) => {
    var list = [];
    props.map((dt, i) => {
      var obj = {
        Id: "123",
        FoodItemId: "123",
        KeywordTagId: dt.id,
        CreationId: "123",
        Status: "Add",
      };
      list.push(obj);
    });
    setKeywordTagList(list);
    setKeywordTagsErr(false);
  };

  //keywordtag end

  useEffect(() => {
    loadAddons(restaurantAdded);
    loadRestaurantName();
    loadKeywordTags();
  }, [restaurantAdded]);

  useEffect(() => {
    loadKeyword();
  }, [restaurantDatas]);

  useEffect(() => {
    loadMenuData(selectedRestaurantDatas);
    loadAddons(selectedRestaurantDatas);
  }, [selectedRestaurantDatas]);

  useEffect(() => {
    var PreSelectedMenu = Menudata.find((x) => x?.id == props.selectedMenu?.id);
    let menuList = [];
    if (PreSelectedMenu !== undefined) {
      menuList.push(PreSelectedMenu);
      setSelectedMenuDatas(menuList);
    }
  }, [Menudata, props.selectedMenu]);

  useEffect(() => {
    loadSectionData(selectedMenuDatas);
  }, [selectedMenuDatas]);

  useEffect(() => {
    console.log("rowsDatas", rowsData);
  }, [rowsData]);

  const [inventoryData, setinventoryData] = React.useState([]);

  const handleInventorySave = (data) => {
    setinventoryData((prev) => {
      if (prev) {
        return [...prev, data];
      }
    });
    //alert(data);
  };

  const onSave = async () => {
    var valid = true;

    // Validate countable addon linking
    rowsData.forEach((row, index) => {
      if (row.isCountable && row.isCountableLinked) {
        // For countable addons, all options must be linked when the addon is linked
        const allOptionsLinked = row.option.every((opt) => opt.isLinked);
        if (!allOptionsLinked) {
          toast.error(
            `All options in countable addon "${row.AddonName}" must be linked when the addon is linked.`,
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            },
          );
          valid = false;
        }
      }
    });

    if (selectedRestaurantDatas.length == 0) {
      setRestaurantErr(true);
      valid = false;
    }
    if (selectedMenuDatas.length == 0) {
      setMainsectionErr(true);
      valid = false;
    }
    if (selectedSectionDatas.length == 0) {
      setSectionErr(true);
      valid = false;
    }
    if (!!selectedItemValue == false) {
      setItemNameErr(true);
      valid = false;
    }
    if (!!descirptionVal == false) {
      setDescriptionErr(true);
      valid = false;
    }
    if (keywordObjlist.length == 0) {
      setKeywordErr(true);
      valid = false;
    }
    if (keywordTagList.length == 0) {
      setKeywordTagsErr(true);
      valid = false;
    }
    if (!!priceExclusive == false) {
      setPriceErr(true);
      valid = false;
    }
    // if (radiovalue == "Specify" && !!vatInAmount == false) {
    //   valid = false;
    //   setVatErr(true);
    // }

    // Accept 0 as valid input
    if (radiovalue == "Specify" && vatInAmount === undefined) {
      setVatErr(true);
      valid = false;
    }

    // Section-specific validation using inventoryData
    selectedSectionDatas.forEach((section) => {
      const sectionId = section.id;
      const sectionTitle = section.title || "Untitled Section";

      // Check if inventory data exists for the current section
      const matchingInventory = inventoryData.find((data) => {
        // Check if the object has the `sectionId` as a key
        return Object.keys(data).includes(sectionId);
      });
    });

    //FoodItems start
    FoodItemInsertView.FoodItems.Id = "123";
    FoodItemInsertView.FoodItems.ItemName = selectedItemValue;
    FoodItemInsertView.FoodItems.Description = descirptionVal;
    FoodItemInsertView.FoodItems.MainSectionId = descirptionVal;
    FoodItemInsertView.FoodItems.SectionId = descirptionVal;
    FoodItemInsertView.FoodItems.IsSubSection = switchCheck;
    FoodItemInsertView.FoodItems.SubSectionId = "s";
    FoodItemInsertView.FoodItems.ItemBasePrice = priceExclusive;
    FoodItemInsertView.FoodItems.VATType = radiovalue;
    FoodItemInsertView.FoodItems.restaurantId = "";
    FoodItemInsertView.FoodItems.MinimumOrderSize = minimumOrderSize ?? 0;
    FoodItemInsertView.FoodItems.MinimumIncrementSize = minimumIncreamentSize;
    // if(!!vatInAmount==true){
    //   FoodItemInsertView.FoodItems.SpecifyVATinPercentage=vatInAmount
    // }
    FoodItemInsertView.FoodItems.IsAnyAddOns = false;
    FoodItemInsertView.FoodItems.CreationId = "123";
    FoodItemInsertView.FoodItems.KitchenId = "0";
    //FoodItems end
    //FoodItem_2 start
    if (selectedSectionDatas && selectedSectionDatas.length > 0) {
      let foodItems2List = [];
      let foodItems2Obj = {};
      let vatId;
      let vatPercentage;
      let sdId;
      let sdPercentage;
      let sdFixedAmount;

      let vatOnSdId;
      let vatOnSdPercentage;

      if (radiovalue == "auto") {
        vatId = vatAdded?.id;
        vatPercentage = null;
      } else if (radiovalue == "Specify") {
        vatId = null;
        vatPercentage = parseFloat(vatInAmount);
      }

      if (radiovalueSD == "auto") {
        sdId = sdAdded?.id;
        sdPercentage = null;
        sdFixedAmount = null;
      } else if (radiovalueSD == "Specify") {
        sdId = null;
        sdPercentage = parseFloat(SdInAmount);
        sdFixedAmount = null;
      } else if (radiovalueSD == "Fixed") {
        sdId = null;
        sdPercentage = null;
        sdFixedAmount = SdAmount;
      }

      if (radiovalueVatonSD == "auto") {
        vatOnSdId = vatOnSdAdded?.id;
        vatOnSdPercentage = null;
      } else if (radiovalueVatonSD == "Specify") {
        vatOnSdId = null;
        vatOnSdPercentage = parseFloat(VatOnSdInAmount);
      }

      selectedSectionDatas.forEach((dt) => {
        const matchingKitchen = getkitchens[dt.id];

        let matchsection = null;

        // Find the inventory data corresponding to the current section
        inventoryData.forEach((data) => {
          if (data && data[dt.id]) {
            matchsection = data[dt.id];
          }
        });

        // test
        const sectionMenu = selectedMenuDatas.find(
          (menu) => menu.id === dt.menuId,
        );

        console.log("debug-333: ", sectionMenu);

        const hasOnlyDine = sectionMenu?.menuTypeName === "In-Store";
        const hasOnlyDelivery = sectionMenu?.menuTypeName === "Delivery";
        const hasOnlyCollection = sectionMenu?.isCollectionOnly;

        let finalIsDelivery = sectionStates[dt.id]?.isDeliverable;

        if (hasOnlyDine) {
          finalIsDelivery = false;
        } else {
          finalIsDelivery = true;
        }

        const isOnlyDelivery = dt.menuTypeName === "Delivery";
        foodItems2Obj = {
          Id: "123",
          ItemName: selectedItemValue,
          Description: descirptionVal,
          MainSectionId: dt.menuId,
          SectionId: dt.id,
          IsSubSection: switchCheck,
          SubSectionId: "s",
          ItemBasePrice: priceExclusive,
          VATType: radiovalue,
          VatId: vatId,
          specifyVATinPercentage: vatPercentage,
          IsAnyAddOns: false,
          CreationId: "123",
          RestaurantId: dt.restaurantId,
          KitchenId: matchingKitchen ? matchingKitchen.id : "0",
          SDType: radiovalueSD,
          SDId: sdId,
          SdPercentage: sdPercentage,
          scheduleId: matchsection ? matchsection?.SchedulerId : null,
          // isDelivery: isOnlyDelivery
          //   ? true
          //   : sectionStates[dt.id]?.isDeliverable,
          // isCollectionOnly: isOnlyDelivery
          //   ? true
          //   : sectionStates[dt.id]?.isCollection,
          isDelivery: finalIsDelivery,
          isCollectionOnly:
            hasOnlyCollection || sectionStates[dt.id]?.isCollection,
          MinimumOrderSize: minimumOrderSize ?? 0,
          MinimumIncrementSize: minimumIncreamentSize ?? 1,
          maximumOrderSize: maximumOrderSize ?? 999,
          sdInAmount: sdFixedAmount,
          vatonSDType: radiovalueVatonSD,
          vatonSDId: vatOnSdId,
          vatonSdPercentage: vatOnSdPercentage,
          insertInventoryPostview: matchsection,
        };

        foodItems2List.push(foodItems2Obj);
        FoodItemInsertView.FoodItems_2 = foodItems2List;
      });
    }
    //FooItem_2 end

    //Fooditem sub filter mapper start
    let fooditemSubFilterMapperList = [];
    if (selectedSubSectionValue.length > 0) {
      selectedSubSectionValue.map((dt, i) => {
        var mapperObj = {
          id: "123",
          fooditemId: "123",
          subfilterId: dt.id,
          isActive: true,
          CreationId: "123",
          Status: "Add",
        };
        fooditemSubFilterMapperList.push(mapperObj);
      });
    }
    //Fooditem sub filter mapper end

    FoodItemInsertView.FoodItemDetailList = details; //details object
    FoodItemInsertView.FoodItemInstructionList = instruction ?? []; //instruction object
    FoodItemInsertView.foodItemStory = story ?? null; //story object
    FoodItemInsertView.fooditemSubfilterMapperList =
      fooditemSubFilterMapperList ?? []; //Fooditem sub filter mapper object

    //restaurantMapperlist start
    SetloadingModal(false);
    await restaurantMapper();
    await fileUpload();

    var addonsobj = [];
    var addonsOptionsObj = [];
    selectedAddons.map((dt, i) => {
      const rank = rowsData.find((x) => x.AddonName == dt.title);
      var obj = {
        Id: "123",
        FoodItemId: "123",
        AddOnsId: dt.id,
        CreationId: "123",
        Status: "Add",
        rank: rank?.rank,
        isCountableLinked: rank?.isCountableLinked,
        isMandatory: rank?.isMandatory,
        isMustPick: isMustPick,
      };

      rank?.option.map((op, i) => {
        var optionObj = {
          Id: "123",
          FoodItemId: "123",
          AddOnsId: dt.id,
          optionsId: op.addOnOptionsMaster.id,
          CreationId: "123",
          isCountableLinked: op?.isLinked,
          isMandatory: op?.isMandatory,
          isOptionMustPick: rank?.isOptionMustPick,
        };

        addonsOptionsObj.push(optionObj);
      });

      addonsobj.push(obj);
    });

    FoodItemInsertView.FoodItemKeywordMapperList = keywordObjlist;
    FoodItemInsertView.FoodItemKeywordTagMapperList = keywordTagList;
    FoodItemInsertView.FoodItemAddOnsMapperList = addonsobj;
    FoodItemInsertView.FoodItemSchedulerMapperList = [];
    FoodItemInsertView.foodItemAddOnsOptionsMapperList = addonsOptionsObj;

    if (selectedValue && selectedValue.length > 0) {
      let canceledObjs = [];
      let canceledObj = {};
      selectedValue.forEach((dt) => {
        canceledObj = {
          restaurantId: dt.restaurantId,
          menuId: dt.menuId,
          sectionId: dt.id,
        };
        canceledObjs.push(canceledObj);
        FoodItemInsertView.foodItemSectionMenuRestaurantMapperViews =
          canceledObjs;
      });
    }
    //restaurantMapper list end

    //Additem validation start
    if (
      FoodItemInsertView.FoodItems.RestaurantId == "" ||
      FoodItemInsertView.FoodItems.MainSectionId == "" ||
      FoodItemInsertView.FoodItems.SectionId == "" ||
      FoodItemInsertView.FoodItems.ItemName == "" ||
      FoodItemInsertView.FoodItems.Description == "" ||
      FoodItemInsertView.FoodItems.ItemBasePrice == "" ||
      FoodItemInsertView.FoodItems.ItemImagePath == "" ||
      FoodItemInsertView.FoodItems.VATType == "" ||
      FoodItemInsertView.FoodItems.IsSubSection == undefined
    ) {
      valid = false;
      SetloadingModal(false);
      toast.error("one or more field is empty on Add Item", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    // if (story == undefined) {
    //   valid = false;
    //   SetloadingModal(false);
    //   toast.error("Story is empty", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    //   });
    // }

    // if (instruction.length == 0) {
    //   valid = false;
    //   SetloadingModal(false);
    //   toast.error("Instruction is empty", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    //   });
    // }

    if (details.length == 0) {
      valid = false;
      SetloadingModal(false);
      toast.error("Details is empty", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    // if (addonsobj.length == 0) {
    //   valid = false;
    //   SetloadingModal(false);
    //   toast.error("Addons is empty", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    //   });
    // }
    if (imageFile.length == 0) {
      valid = false;
      SetloadingModal(false);
      toast.error("Upload an image first", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (
      vatInAmount === null ||
      vatInAmount === undefined ||
      vatInAmount === ""
    ) {
      valid = false;
      SetloadingModal(false);
      toast.error("Vat is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    console.log(FoodItemInsertView);
    //Additem validation end
    //valid = true;
    var url = apiAddress + "/api/FoodItems/InsertFoodItem_New";
    if (valid) {
      SetloadingModal(true);
      axios
        .post(url, FoodItemInsertView)
        .then((response) => {
          props.onHandleAddItem(false);
          SetloadingModal(false);
          handleClose();
          toast.success("Successfully Saved", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .catch((error) => {
          SetloadingModal(false);
          toast.error("failed", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  };
  const ReloadAddons = () => {
    //loadAddons();
  };
  const handleAddMenuDialogData = (data) => {
    // setSelectedData(data);
    // loadData();
  };

  const selectedSectionAddedValue = (props) => {
    // Limit the number of items that can be added to 5.
    if (selectedSubSectionValue.length <= 4) {
      setSelectedSubSectionValue(props);
    } else {
      setSelectedSubSectionValue((prevValue) =>
        prevValue.filter((item) => props.some((p) => p.id === item.id)),
      );
    }
  };

  const [openMenu, setOpenMenu] = useState(false);
  const [vatDatas, setvatDatas] = useState([]);
  const [vatAdded, setvatAdded] = useState(null);
  const [radiovalue, setRadiovalue] = useState("auto");
  const [customVat, setCustomVat] = useState("");
  const [isAutocompleteDisabled, setIsAutocompleteDisabled] = useState(false);
  const [isRadioDisabled, setIsRadioDisabled] = useState(false);

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setRadiovalue(value);

    if (value === "Specify") {
      setvatAdded(null); // Clear selected VAT when switching to custom input
      setCustomVat(""); // Reset custom VAT field
    } else {
      setCustomVat(""); // Reset custom VAT when switching to Autocomplete
    }
  };

  useEffect(() => {
    if (!openAddVat) {
      // Runs when dialog closes
      axios
        .get(
          `${apiAddress}/api/Vat/GetAllVatListByRestaurantIdAsync?restaurantId=${RestauranttokenLocal?.id}`,
        )
        .then((response) => {
          const updatedVatList = response.data?.map((dt) => ({
            id: dt.id,
            title: dt.name,
            percentage: dt.percentage,
          }));
          setvatDatas(updatedVatList);
        })
        .catch((error) => {
          console.error("Failed to fetch VAT list:", error);
        });
    }
  }, [openAddVat]);

  useEffect(() => {
    if (vatAdded && vatAdded.percentage !== undefined) {
      setIsactive(false);
      const pct = Number(vatAdded.percentage) || 0;
      setvatInAmount(pct);
      const vatPrice = pct / 100;
      const total = vatPrice * Number(priceExclusive || 0);
      setVatAmount(Number(total.toFixed(2)));
      //setpriceInclusive(parseFloat(priceExclusive) + parseFloat(total));
    } else if (customVat) {
      const cv = Number(customVat) || 0;
      setvatInAmount(cv);
      const vatPrice = cv / 100;
      const total = vatPrice * Number(priceExclusive || 0);
      setVatAmount(Number(total.toFixed(2)));
      //setpriceInclusive(parseFloat(priceExclusive) + parseFloat(total));
    } else {
      setvatInAmount(0);
      setVatAmount(0);
      //setpriceInclusive(0)
    }
  }, [vatAdded, customVat]);

  const handleClickVatOpen = () => {
    setopenAddVat(true);
    setDialogType("Add Vat");
  };

  const [sectionStates, setSectionStates] = useState<
    Record<string, { isDeliverable: boolean; isCollection: boolean }>
  >({});

  const handleDeliverableCheck = (sectionId: string, isChecked: boolean) => {
    setSectionStates((prev) => {
      const updatedState = {
        ...prev,
        [sectionId]: {
          ...prev[sectionId],
          isDeliverable: isChecked,
        },
      };
      return updatedState;
    });
  };

  // const handleCollectionCheck = (sectionId: string, isChecked: boolean) => {
  //   setSectionStates((prev) => {
  //     const updatedState = {
  //       ...prev,
  //       [sectionId]: {
  //         ...prev[sectionId],
  //         isCollection: isChecked,
  //       },
  //     };
  //     return updatedState;
  //   });
  // };

  const handleCollectionCheck = (sectionId: string, isChecked: boolean) => {
    const sectionInfo = sectionTitles[sectionId] || {
      isRestaurantCollectionOnly: false,
    };
    //if (sectionInfo.isRestaurantCollectionOnly) return; // Don't allow changes if restaurant is collection only

    setSectionStates((prev) => {
      const updatedState = {
        ...prev,
        [sectionId]: {
          ...prev[sectionId],
          isCollection: isChecked,
        },
      };
      return updatedState;
    });
  };

  const [radiovalueSD, setRadiovalueSD] = useState("auto");
  const [customSD, setCustomSD] = useState("");
  const [sdDatas, setsdDatas] = useState([]);
  const [sdAdded, setsdAdded] = useState(null);
  const [SdAmount, setSdAmount] = useState(0);
  const [SdInAmount, setSdInAmount] = useState(0.0);

  const [radiovalueVatonSD, setRadiovalueVatonSD] = useState("auto");
  const [customVatonSD, setCustomVatonSD] = useState("");
  //const [sdDatas, setsdDatas] = useState([]);
  const [vatOnSdAdded, setVatOnSdAdded] = useState(null);
  const [VatOnSdAmount, setVatOnSdAmount] = useState(0);
  const [VatOnSdInAmount, setVatOnSdInAmount] = useState(0.0);

  const handleRadioChangeSD = (event) => {
    const value = event.target.value;
    setRadiovalueSD(value);

    if (value === "Specify") {
      setsdAdded(null); // Clear selected VAT when switching to custom input
      setCustomSD(""); // Reset custom VAT field
    } else if (value === "auto") {
      setCustomSD(""); // Reset custom VAT when switching to Autocomplete
    } else if (value === "Fixed") {
      setSdAmount(0);
      setSdInAmount("");
    }
  };

  const inAmountSDValue = (props) => {
    if (radiovalueSD === "Specify") {
    } else if (radiovalueSD === "auto") {
    } else if (radiovalueSD === "Fixed") {
      setSdAmount(props);
    }
  };

  const inPercentageSDValue = (props) => {
    // var Vatprice = props / 100;
    // var total = Vatprice * priceExclusive;
    // setVatAmount(total);
    // setvatInAmount(props);
    // setpriceInclusive(parseInt(priceExclusive) + parseInt(total));
    // setVatErr(false);
  };

  function getPercentageOrAmount(
    amount1: number,
    amount2: number,
    mode: string,
  ): number | string {
    if (mode === "percentage") {
      return (amount2 / amount1) * 100; // amount2 is what percentage of amount1
    } else if (mode === "amount") {
      return (amount1 * amount2) / 100; // amount2% of amount1
    } else {
      return "Invalid mode";
    }
  }

  useEffect(() => {
    if (sdAdded && sdAdded.percentage) {
      setIsactive(false);
      const pct = Number(sdAdded.percentage) || 0;
      setSdInAmount(pct);
      const sdPrice = pct / 100;
      const total = sdPrice * Number(priceExclusive || 0);
      setSdAmount(Number(total.toFixed(2)));
    } else if (customSD) {
      const csd = Number(customSD) || 0;
      setSdInAmount(csd);
      const total = (csd / 100) * Number(priceExclusive || 0);
      setSdAmount(Number(total.toFixed(2)));
    } else {
      setSdInAmount(0);
      setSdAmount(0);
    }
  }, [sdAdded, customSD]);
  const [showSD, setShowSD] = useState(false);
  const [showVatOnSD, setShowVatOnSD] = useState(false);

  useEffect(() => {
    if (!showSD) {
      setSdInAmount(0);
      setSdAmount(0);
      return;
    }

    const pe = parseFloat(priceExclusive || 0);

    let sdPercentage = 0;
    let sdAmt = 0;

    if (radiovalueSD === "auto" && sdAdded?.percentage) {
      sdPercentage = parseFloat(sdAdded.percentage);
      sdAmt = pe * (sdPercentage / 100);
    } else if (radiovalueSD === "Specify" && customSD) {
      sdPercentage = parseFloat(customSD);
      sdAmt = pe * (sdPercentage / 100);
    } else if (radiovalueSD === "Fixed" && SdAmount) {
      sdAmt = parseFloat(SdAmount);
      sdPercentage = (sdAmt / pe) * 100;
    }

    setSdInAmount(sdPercentage.toFixed(2));
    setSdAmount(sdAmt.toFixed(2));
  }, [showSD, priceExclusive, radiovalueSD, sdAdded, customSD, SdAmount]);

  // 3. VAT on SD Calculation useEffect
  useEffect(() => {
    if (!showSD) {
      setVatOnSdAmount(0);
      setVatOnSdInAmount(0);
      return;
    }

    const sdAmt = parseFloat(SdAmount || 0);

    let vatOnSdPercentage = 0;
    let vatOnSdAmt = 0;

    if (radiovalueVatonSD === "auto" && vatOnSdAdded?.percentage) {
      vatOnSdPercentage = parseFloat(vatOnSdAdded.percentage);
      vatOnSdAmt = sdAmt * (vatOnSdPercentage / 100);
    } else if (radiovalueVatonSD === "Specify" && customVatonSD) {
      vatOnSdPercentage = parseFloat(customVatonSD);
      vatOnSdAmt = sdAmt * (vatOnSdPercentage / 100);
    }

    setVatOnSdInAmount(vatOnSdPercentage.toFixed(2));
    setVatOnSdAmount(vatOnSdAmt.toFixed(2));
  }, [showSD, SdAmount, radiovalueVatonSD, vatOnSdAdded, customVatonSD]);

  // 4. Final Price Calculation useEffect
  useEffect(() => {
    const pe = parseFloat(priceExclusive || 0);

    // VAT calculation
    const vatRate = parseFloat(vatInAmount || 0) / 100;
    const vatAmt = pe * vatRate;

    // SD calculation (only if SD is enabled)
    const sdAmt = showSD ? parseFloat(SdAmount || 0) : 0;

    // VAT on SD calculation (only if SD is enabled)
    const vatOnSdAmt = showSD ? parseFloat(VatOnSdAmount || 0) : 0;

    // Update individual amounts
    setVatAmount(vatAmt.toFixed(2));

    // Calculate inclusive price
    const inclusive = pe + vatAmt + sdAmt + vatOnSdAmt;
    setpriceInclusive(inclusive.toFixed(2));
  }, [priceExclusive, vatInAmount, showSD, SdAmount, VatOnSdAmount]);

  useEffect(() => {
    const value =
      Number(priceExclusive || 0) +
      Number(vatAmount || 0) +
      Number(SdAmount || 0);
    setpriceInclusive(Number(value.toFixed(2)));
  }, [vatAmount]);

  useEffect(() => {
    const value =
      Number(priceExclusive || 0) +
      Number(vatAmount || 0) +
      Number(SdAmount || 0);
    setpriceInclusive(Number(value.toFixed(2)));
  }, [SdAmount]);

  const handleRadioChangeVatOnSD = (event) => {
    const value = event.target.value;
    setRadiovalueVatonSD(value);

    if (value === "Specify") {
      setVatOnSdAdded(null); // Clear selected VAT when switching to custom input
      setCustomVatonSD(""); // Reset custom VAT field
    } else {
      setCustomVatonSD(""); // Reset custom VAT when switching to Autocomplete
    }
  };

  useEffect(() => {
    if (vatOnSdAdded && vatOnSdAdded.percentage) {
      setIsactive(false);
      const pct = Number(vatOnSdAdded.percentage) || 0;
      setVatOnSdInAmount(pct);
      const sdPrice = pct / 100;
      const total = sdPrice * Number(SdAmount || 0);
      setVatOnSdAmount(Number(total.toFixed(2)));
    } else if (customVatonSD) {
      const cvs = Number(customVatonSD) || 0;
      setVatOnSdInAmount(cvs);
      const total = (cvs / 100) * Number(SdAmount || 0);
      setVatOnSdAmount(Number(total.toFixed(2)));
    } else {
      setVatOnSdInAmount(0);
      setVatOnSdAmount(0);
    }
  }, [vatOnSdAdded, customVatonSD]);

  useEffect(() => {
    const value =
      Number(priceExclusive || 0) +
      Number(vatAmount || 0) +
      Number(SdAmount || 0) +
      Number(VatOnSdAmount || 0);
    setpriceInclusive(Number(value.toFixed(2)));
  }, [VatOnSdAmount]);

  const tabs = [
    { label: "Add item", value: "1" },
    { label: "Details", value: "2" },
    { label: "Story", value: "3" },
    { label: "Instruction", value: "4" },
    { label: "Kitchen", value: "5" },
  ];

  //const [value, setValue] = useState("1");

  const currentIndex = tabs.findIndex((tab) => tab.value === value);

  const goToNextTab = () => {
    if (currentIndex < tabs.length - 1) {
      setValue(tabs[currentIndex + 1].value);
    }
  };

  const goToPreviousTab = () => {
    if (currentIndex > 0) {
      setValue(tabs[currentIndex - 1].value);
    }
  };

  const RestaurantLocaltoken = JSON.parse(localStorage.getItem("restaurant"));
  useEffect(() => {
    var PreFetchedRestaurant = restaurantDatas.find(
      (x) => x.id == RestaurantLocaltoken.id,
    );
    if (PreFetchedRestaurant) {
      let resList = [];
      let resList1 = [];
      resList.push(PreFetchedRestaurant);

      resList.map((dt, i) => {
        resList1.push(dt.id);
      });
      setSelectedRestaurantDatas(resList);
      setRestaurantArray(resList1);
    }
  }, [restaurantDatas]);

  // end//

  return (
    <>
      <div>
        <SweetAlertModal
          headerText={"Do you want to leave without saving?"}
          bodyText={"All changes made will be lost"}
          open={openConfirmaitonModal}
          onyes={handleAddDialogClose}
          close={() => {
            setopenConfirmaitonModal(false);
          }}
          id={2}
        />
        <ToastContainer />
        <React.Fragment>
          <Dialog
            fullWidth={true}
            maxWidth={"xl"}
            open={props.open}
            onClose={handleClose}
          >
            <LoadingView open={loadingModal} close={closeLoadingModal} />
            <Grid container>
              <Grid item xs={6}>
                <DialogTitle>
                  <div className="d-flex" style={{ gap: "8px" }}>
                    <div>
                      <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                    </div>

                    <span style={{ color: "#2a7fd4" }}>
                      GoTaste :- Add item for {RestaurantNames.join(", ")}
                    </span>
                  </div>
                </DialogTitle>
              </Grid>
              <Grid item xs={6}>
                <DialogActions>
                  <Button onClick={() => setopenConfirmaitonModal(true)}>
                    <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                  </Button>
                </DialogActions>
              </Grid>
            </Grid>
            <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
              <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps: { completed?: boolean } = {};
                  const labelProps: {
                    optional?: React.ReactNode;
                  } = {};

                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              {/* {
              (activeStep === 0 ? ( */}
              <div className={`${activeStep == 0 ? "d-block " : "d-none"} `}>
                {/* checked */}
                <React.Fragment>
                  <div
                    className="d-flex justify-content-end"
                    style={{ gap: "10px" }}
                  >
                    <img
                      src={importImg}
                      alt=""
                      style={{ width: "1.5rem" }}
                      onClick={() => {
                        setOpenImport(!openImport);
                      }}
                    />
                    <span>Import</span>
                  </div>

                  <ImportItemView
                    open={openImport}
                    dialogType={dialogType}
                    onHandleAddItem={handleImportItem}
                  />

                  {/* <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab label="Add item" value="1" />
                        <Tab label="Details" value="2" />
                        <Tab label="Story" value="3" />
                        <Tab label="Instruction" value="4" />
                        <Tab label="Kitchen" value="5" />
                      </TabList>
                    </Box>
                  </TabContext> */}
                  {/* {value === '1' && ( */}

                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        {tabs.map((tab) => (
                          <Tab
                            key={tab.value}
                            label={tab.label}
                            value={tab.value}
                          />
                        ))}
                      </TabList>
                    </Box>
                  </TabContext>

                  {/* Error area start , 3 ta autocomplete commented*/}

                  <div className={`${value == "1" ? "d-block " : "d-none"} `}>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <div
                          className="d-flex"
                          style={{ paddingTop: "1rem", gap: "10px" }}
                        >
                          <Typography>Restaurant</Typography>
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        <Autocomplete
                          multiple
                          id="restaurant-dropdown"
                          options={restaurantDatas}
                          value={selectedRestaurantDatas}
                          onChange={(event, newInputValue, reason, detail) => {
                            setSelectedRestaurantDatas(newInputValue);
                            setRestaurantErr(false);
                            if (reason === "removeOption") {
                              handleRemoveData(detail.option);
                            } else {
                              handleRestaurantChange(detail.option);
                            }
                          }}
                          className="my-3"
                          getOptionLabel={(option) => option.title}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label="Restaurant"
                            />
                          )}
                        />
                        {RestaurantErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Menu
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Autocomplete
                          multiple
                          id="tags-outlined"
                          options={Menudata}
                          value={selectedMenuDatas}
                          onChange={(event, newInputValue, reason, detail) => {
                            setSelectedMenuDatas(newInputValue);
                            setMainsectionErr(false);
                            if (reason === "removeOption") {
                              // handleRemoveData(detail.option);
                              handleMenuChange(detail.option);
                            }
                          }}
                          className="my-3"
                          getOptionLabel={(option) => option.title}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Filter/Section"
                              placeholder="Filter/Section"
                            />
                          )}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                              {...props}
                            >
                              <img
                                loading="lazy"
                                src={option.img}
                                alt=""
                                style={{ width: "2rem" }}
                              />
                              <div
                                className="d-flex "
                                style={{ flexDirection: "column" }}
                              >
                                <div className="d-flex" style={{ gap: "10px" }}>
                                  <h5 className="mb-0">{option.title}</h5>
                                </div>

                                <span
                                  className="text-muted"
                                  style={{ fontSize: "1rem", marginTop: "0" }}
                                >
                                  {" "}
                                  {option.restaurantName}
                                </span>
                              </div>
                            </Box>
                          )}
                        />

                        {MainsectionErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        className="AddItemplusIcon"
                        onClick={() => setOpenMenu(true)}
                      >
                        <button className="modalAddButton">
                          +Add Main Section
                        </button>
                        {/* <img src={plusIcon} alt="+" /> */}
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <div
                          className="d-flex"
                          style={{ paddingTop: "1rem", gap: "10px" }}
                        >
                          <Typography>Section/Filter</Typography>
                          <HtmlTooltip
                            title={
                              <React.Fragment>
                                <Typography color="inherit">
                                  Select a section category for this food item
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoOutlinedIcon style={{ color: "#371B17" }} />
                          </HtmlTooltip>
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        <Autocomplete
                          multiple
                          id="restaurant-dropdown"
                          options={Sectiondata}
                          value={selectedSectionDatas}
                          onChange={(event, newInputValue) => {
                            setSelectedSectionDatas(newInputValue);
                            handleSectionChange(newInputValue);
                            setSectionErr(false);
                          }}
                          className="my-3"
                          getOptionLabel={(option) => option.title}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label="Select Section"
                            />
                          )}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                              {...props}
                            >
                              <img
                                loading="lazy"
                                src={option.img}
                                alt=""
                                style={{ width: "2rem" }}
                              />
                              <div
                                className="d-flex "
                                style={{ flexDirection: "column" }}
                              >
                                <div className="d-flex" style={{ gap: "10px" }}>
                                  <h5 className="mb-0">{option.title}</h5>
                                </div>

                                <span
                                  className="text-muted"
                                  style={{ fontSize: "1rem", marginTop: "0" }}
                                >
                                  {" "}
                                  {option.restaurantName}
                                </span>
                              </div>
                            </Box>
                          )}
                        />

                        {SectionErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                      <Grid item xs={1} className="AddItemplusIcon">
                        <button
                          className="modalAddButton"
                          onClick={handleClickOpen}
                        >
                          +Add Section
                        </button>
                      </Grid>
                    </Grid>
                    {/* Sub section / Sub filter */}
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Sub section/Sub filter
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Switch
                          checked={switchCheck}
                          onChange={handleSwitchChange}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </Grid>
                    </Grid>
                    {switchCheck && (
                      <Grid container sx={{ padding: "0.5rem" }}>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={9} style={{ paddingTop: "1rem" }}>
                          <AutoCompleteMultiSelect
                            id={88}
                            placeholder={"Select a Sub Filter"}
                            datas={subSectionImage}
                            value={selectedSectionAddedValue}
                            val={selectedSubSectionValue}
                          />
                        </Grid>

                        <Grid item xs={1} className="AddItemplusIcon">
                          <button
                            className="modalAddButton"
                            onClick={handleClickOpenOk}
                          >
                            +Add Sub Filter
                          </button>
                        </Grid>
                      </Grid>
                    )}

                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Item Name
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <TextAreaComponents
                          label={"Item name"}
                          value={nameValue}
                          val={selectedItemValue}
                        />
                        {ItemNameErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Description
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <TextAreaComponents
                          id={1}
                          label={"Description"}
                          value={descirptionValue}
                          val={descirptionVal}
                        />
                        {DescriptionErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Image
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <Button
                          variant="contained"
                          component="label"
                          //   color="primary"
                          style={{ backgroundColor: "white", color: "gray" }}
                        >
                          <img
                            src={galleryIcon}
                            alt="upload-icon"
                            style={{ width: "2rem" }}
                          />
                          Upload
                          <input
                            hidden
                            accept="image/*"
                            multiple
                            type="file"
                            onChange={handleImageUpload}
                            disabled={state.selectedImages.length >= 5}
                          />
                        </Button>
                      </Grid>

                      {/* image show start */}
                      <Grid container sx={{ padding: "0.5rem" }}>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={9}>
                          <Grid container spacing={2}>
                            {state.selectedImages.map((image, index) => (
                              <Grid item xs={2} sm={2} md={2} key={index}>
                                {/* <Paper> */}
                                <div
                                  style={{
                                    position: "relative",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <img
                                    src={image}
                                    alt={`Preview ${index + 1}`}
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <IconButton
                                    style={{
                                      position: "absolute",
                                      top: "-6px",
                                      right: "-23px",
                                      color: "gray",
                                    }}
                                    onClick={() => handleDeleteImage(index)}
                                  >
                                    <CancelIcon />
                                  </IconButton>
                                </div>
                                {/* </Paper> */}
                              </Grid>
                            ))}
                          </Grid>
                          <div style={{ paddingTop: "1rem" }}>
                            {ImageErr && (
                              <span style={{ color: "red" }}>
                                This field is required
                              </span>
                            )}
                          </div>
                        </Grid>
                      </Grid>
                      {/* image show end */}
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <div
                          className="d-flex"
                          style={{ paddingTop: "1rem", gap: "10px" }}
                        >
                          <Typography>Keywords</Typography>
                          <HtmlTooltip
                            title={
                              <React.Fragment>
                                <Typography color="inherit">
                                  Add up to 4 keyword filters to identify the
                                  item. Sub-filters that were previously added
                                  can be re-used across your menus
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoOutlinedIcon style={{ color: "#371B17" }} />
                          </HtmlTooltip>
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        <Autocomplete
                          multiple
                          id="free-solo-with-text-demo"
                          options={keywordDatas.map((option) => option.title)}
                          freeSolo
                          onChange={handleKeywordChange}
                          renderTags={(value: readonly string[], getTagProps) =>
                            value.map((option: string, index: number) => (
                              <Chip
                                variant="outlined"
                                label={option}
                                {...getTagProps({ index })}
                              />
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={"Keywords"}
                              onKeyDown={handleKeyDown}
                            />
                          )}
                        />
                        {KeywordErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                      <Grid item xs={1} className="AddItemplusIcon">
                        {/* <img src={plusIcon} alt="+" onClick={handleClickKeyword} /> */}
                        <button
                          className="modalAddButton"
                          onClick={handleClickKeyword}
                        >
                          +Add Keywords
                        </button>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Keywords tags
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <AutoCompleteMultiSelect
                          label={"Keywords tags"}
                          placeholder={"Keywords tags"}
                          value={addkeywordtag}
                          datas={keywordTagdata}
                          id={2}
                        />
                        {KeywordTagsErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Minimum Order Size
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <TextAreaComponents
                          id={2}
                          label={"Minimum Order Size"}
                          value={AddMinimumOrderValue}
                          val={minimumOrderSize}
                        />
                        {PriceErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Maximum Order Size
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <TextAreaComponents
                          id={2}
                          label={"Maximum Order Size"}
                          value={AddMaximumOrderValue}
                          val={maximumOrderSize}
                        />
                        {PriceErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Minimum Increment Size
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <TextAreaComponents
                          id={2}
                          label={"Minimum Increment Size"}
                          value={AddMinimumIncreamentValue}
                          val={minimumIncreamentSize}
                        />
                        {PriceErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Price (Exclusive of Vat)
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <TextAreaComponents
                          id={2}
                          label={"Price (Exclusive)"}
                          value={setpriceExclusiveval}
                          val={
                            priceExclusive
                            // priceExclusive !== undefined &&
                            //   priceExclusive !== null &&
                            //   priceExclusive !== ''
                            //   ? Number(priceExclusive).toFixed(2)
                            //   : ''
                          }
                        />
                        {PriceErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          VAT (Amount)
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <Grid xs={5}>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={radiovalue}
                            onChange={handleRadioChange}
                          >
                            <FormControlLabel
                              value="auto"
                              control={<Radio />}
                              label="Select from VAT List"
                            />
                            <span
                              style={{
                                paddingTop: "0.5rem",
                                paddingRight: "0.5rem",
                              }}
                            >
                              {" "}
                              - Or -{" "}
                            </span>

                            <FormControlLabel
                              value="Specify"
                              control={<Radio />}
                              label="Specify VAT"
                            />
                          </RadioGroup>

                          {radiovalue === "auto" && (
                            <Grid container alignItems="center">
                              <Grid item xs>
                                <Autocomplete
                                  id="free-solo-with-text-demo"
                                  options={vatDatas}
                                  value={vatAdded}
                                  onChange={(event, newInputValue) => {
                                    setvatAdded(newInputValue);
                                  }}
                                  className="my-3"
                                  getOptionLabel={(option) =>
                                    option?.title || ""
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      label="Select VAT"
                                      disabled={radiovalue !== "auto"}
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item>
                                <button
                                  className="modalAddButton"
                                  onClick={handleClickVatOpen}
                                >
                                  +Add Vat
                                </button>
                              </Grid>
                            </Grid>
                          )}

                          {radiovalue === "Specify" && (
                            <TextField
                              label="Specify VAT Percentage"
                              variant="outlined"
                              value={customVat}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || Number(value) >= 0) {
                                  // Ensure the value is valid or empty
                                  setCustomVat(value);
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "-" || e.key === "e") {
                                  e.preventDefault(); // Prevent typing "-" or "e" in the input
                                }
                              }}
                              className="my-3"
                              type="number"
                              placeholder="Enter VAT percentage"
                            />
                          )}
                        </Grid>
                        <div>
                          <Grid container>
                            <Grid xs={3.5}>
                              <TextAreaComponents
                                id={2}
                                label={"VAT (%)"}
                                value={inPercentageVATValue}
                                //val={vatInAmount !== 0 ? vatInAmount : ""}
                                val={vatInAmount ?? ""}
                                isactive={isactive}
                                placeholder={"VAT (%)"}
                              />
                              {VatErr && (
                                <span style={{ color: "red" }}>
                                  This field is required
                                </span>
                              )}
                            </Grid>
                            <Grid xs={3} className="ms-2">
                              <TextAreaComponents
                                id={2}
                                label={"VAT (Amount)"}
                                value={inAmountVATValue}
                                val={vatAmount}
                                isactive={isactive}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      alignItems="center"
                      sx={{ padding: "0.5rem" }}
                    >
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          SD
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <Switch
                          checked={showSD}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setShowSD(isChecked);
                            if (!isChecked) {
                              // Clear all SD and VAT on SD values
                              setRadiovalueSD("auto");
                              setsdAdded(null);
                              setCustomSD("");
                              setSdAmount(0);
                              setSdInAmount(0);

                              // Clear VAT on SD values
                              setRadiovalueVatonSD("auto");
                              setVatOnSdAdded(null);
                              setCustomVatonSD("");
                              setVatOnSdAmount(0);
                              setVatOnSdInAmount(0);
                            }
                          }}
                          color="primary"
                        />
                        <Typography component="span" sx={{ ml: 1 }}>
                          {showSD ? "" : ""}
                        </Typography>
                      </Grid>
                    </Grid>

                    {showSD && (
                      <>
                        <Grid container sx={{ padding: "0.5rem" }}>
                          <Grid xs={2}></Grid>
                          <Grid xs={9}>
                            <Grid xs={6}>
                              <RadioGroup
                                row
                                name="row-radio-buttons-group"
                                value={radiovalueSD}
                                onChange={handleRadioChangeSD}
                              >
                                <FormControlLabel
                                  value="auto"
                                  control={<Radio />}
                                  label="Select from SD List"
                                />
                                <span
                                  style={{
                                    paddingTop: "0.5rem",
                                    paddingRight: "0.5rem",
                                  }}
                                >
                                  - Or -
                                </span>
                                <FormControlLabel
                                  value="Specify"
                                  control={<Radio />}
                                  label="Specify SD"
                                />
                                <span
                                  style={{
                                    paddingTop: "0.5rem",
                                    paddingRight: "0.5rem",
                                  }}
                                >
                                  - Or -
                                </span>
                                <FormControlLabel
                                  value="Fixed"
                                  control={<Radio />}
                                  label="Fixed SD"
                                />
                              </RadioGroup>

                              {radiovalueSD === "auto" && (
                                <Grid container alignItems="center">
                                  <Grid item xs={7}>
                                    <Autocomplete
                                      options={vatDatas}
                                      value={sdAdded}
                                      onChange={(e, val) => setsdAdded(val)}
                                      className="my-3"
                                      getOptionLabel={(option) =>
                                        option?.title || ""
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Select SD"
                                        />
                                      )}
                                    />
                                  </Grid>
                                </Grid>
                              )}

                              {radiovalueSD === "Specify" && (
                                <TextField
                                  label="Specify SD Percentage"
                                  variant="outlined"
                                  value={customSD}
                                  type="number"
                                  className="my-3"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === "" || Number(value) >= 0) {
                                      setCustomSD(value);
                                    }
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "-" || e.key === "e")
                                      e.preventDefault();
                                  }}
                                />
                              )}

                              {radiovalueSD === "Fixed" && (
                                <TextField
                                  label="Fixed SD Amount"
                                  variant="outlined"
                                  value={SdAmount}
                                  type="number"
                                  className="my-3"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === "" || Number(value) >= 0) {
                                      setSdAmount(value);
                                    }
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "-" || e.key === "e")
                                      e.preventDefault();
                                  }}
                                />
                              )}
                            </Grid>

                            <Grid container>
                              <Grid xs={3.5}>
                                <TextAreaComponents
                                  label={"SD (%)"}
                                  val={SdInAmount !== 0 ? SdInAmount : ""}
                                  isactive={isactive}
                                />
                              </Grid>
                              <Grid xs={3} className="ms-2">
                                <TextAreaComponents
                                  label={"SD (Amount)"}
                                  val={SdAmount}
                                  isactive={isactive}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        {/* VAT on SD - Automatically shown when SD is enabled, no toggle needed */}
                        <Grid
                          container
                          sx={{
                            padding: "0.5rem",
                            borderRadius: "8px",
                            marginTop: "1rem",
                          }}
                        >
                          <Grid xs={2}>
                            <Typography style={{ paddingTop: "1rem" }}>
                              VAT on SD
                            </Typography>
                          </Grid>
                          <Grid xs={9}>
                            <Grid xs={6}>
                              <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={radiovalueVatonSD}
                                onChange={handleRadioChangeVatOnSD}
                              >
                                <FormControlLabel
                                  value="auto"
                                  control={<Radio />}
                                  label="Select from VAT List"
                                />
                                <span
                                  style={{
                                    paddingTop: "0.5rem",
                                    paddingRight: "0.5rem",
                                  }}
                                >
                                  {" "}
                                  - Or -{" "}
                                </span>
                                <FormControlLabel
                                  value="Specify"
                                  control={<Radio />}
                                  label="Specify VAT on SD"
                                />
                              </RadioGroup>

                              {radiovalueVatonSD === "auto" && (
                                <Grid container alignItems="center">
                                  <Grid item xs={7}>
                                    <Autocomplete
                                      id="free-solo-with-text-demo"
                                      options={vatDatas}
                                      value={vatOnSdAdded}
                                      onChange={(event, newInputValue) => {
                                        setVatOnSdAdded(newInputValue);
                                      }}
                                      className="my-3"
                                      getOptionLabel={(option) =>
                                        option?.title || ""
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          variant="outlined"
                                          label="Select VAT"
                                          disabled={
                                            radiovalueVatonSD !== "auto"
                                          }
                                        />
                                      )}
                                    />
                                  </Grid>
                                </Grid>
                              )}

                              {radiovalueVatonSD === "Specify" && (
                                <TextField
                                  label="Specify VAT Percentage"
                                  variant="outlined"
                                  value={customVatonSD}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === "" || Number(value) >= 0) {
                                      setCustomVatonSD(value);
                                    }
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "-" || e.key === "e") {
                                      e.preventDefault();
                                    }
                                  }}
                                  className="my-3"
                                  type="number"
                                  placeholder="Enter VAT percentage"
                                />
                              )}
                            </Grid>
                            <div>
                              <Grid container>
                                <Grid xs={3.5}>
                                  <TextAreaComponents
                                    id={2}
                                    label={"VAT (%)"}
                                    value={inPercentageVATValue}
                                    val={
                                      VatOnSdInAmount !== 0
                                        ? VatOnSdInAmount
                                        : ""
                                    }
                                    isactive={isactive}
                                    placeholder={"VAT (%)"}
                                  />
                                  {VatErr && (
                                    <span style={{ color: "red" }}>
                                      This field is required
                                    </span>
                                  )}
                                </Grid>
                                <Grid xs={3} className="ms-2">
                                  <TextAreaComponents
                                    id={2}
                                    label={"VAT (Amount)"}
                                    value={inAmountVATValue}
                                    val={VatOnSdAmount}
                                    isactive={isactive}
                                  />
                                </Grid>
                              </Grid>
                            </div>
                          </Grid>
                        </Grid>
                      </>
                    )}
                    {/* <Grid container alignItems="center" sx={{ padding: "0.5rem" }}>
  <Grid xs={2}>
    <Typography style={{ paddingTop: "1rem" }}>
      VAT On SD
    </Typography>
  </Grid>

  <Grid xs={9}>
    <Switch
      checked={showVatOnSD}
      onChange={(e) => setShowVatOnSD(e.target.checked)}
      color="primary"
    />
    <Typography component="span" sx={{ ml: 1 }}>
      {showVatOnSD ? "Enabled" : "Disabled"}
    </Typography>
  </Grid>
</Grid>
{showVatOnSD && (
    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          VAT On SD
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <Grid xs={6}>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={radiovalueVatonSD}
                            onChange={handleRadioChangeVatOnSD}
                          >
                            <FormControlLabel
                              value="auto"
                              control={<Radio />}
                              label="Select from VAT List"
                            />
                            <span style={{ paddingTop: "0.5rem", paddingRight: "0.5rem" }} > - Or - </span>

                            <FormControlLabel
                              value="Specify"
                              control={<Radio />}
                              label="Specify VAT On SD"
                            />
                          </RadioGroup>


                          {radiovalueVatonSD === "auto" && (
                            <Grid container alignItems="center">
                              <Grid item xs={7}>
                                <Autocomplete
                                  id="free-solo-with-text-demo"
                                  options={vatDatas}
                                  value={vatOnSdAdded}
                                  onChange={(event, newInputValue) => {
                                    setVatOnSdAdded(newInputValue);
                                  }}
                                  className="my-3"
                                  getOptionLabel={(option) => option?.title || ""}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      label="Select VAT"
                                      disabled={radiovalue !== "auto"}
                                    />
                                  )}
                                />
                              </Grid>
                            </Grid>
                          )}


                          {radiovalueVatonSD === "Specify" && (
                            <TextField
                              label="Specify VAT Percentage"
                              variant="outlined"
                              value={customVatonSD}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || Number(value) >= 0) { // Ensure the value is valid or empty
                                  setCustomVatonSD(value);
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "-" || e.key === "e") {
                                  e.preventDefault(); // Prevent typing "-" or "e" in the input
                                }
                              }}
                              className="my-3"
                              type="number"
                              placeholder="Enter VAT percentage"
                            />
                          )}
                        </Grid>
                        <div>
                          <Grid container>
                            <Grid xs={3.5}>
                              <TextAreaComponents
                                id={2}
                                label={"VAT (%)"}
                                value={inPercentageVATValue}
                                val={VatOnSdInAmount !== 0 ? VatOnSdInAmount : ""}
                                isactive={isactive}
                                placeholder={"VAT (%)"}
                              />
                              {VatErr && (
                                <span style={{ color: "red" }}>
                                  This field is required
                                </span>
                              )}
                            </Grid>
                            <Grid xs={3} className="ms-2">
                              <TextAreaComponents
                                id={2}
                                label={"VAT (Amount)"}
                                value={inAmountVATValue}
                                val={VatOnSdAmount}
                                isactive={isactive}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>
)} */}

                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Price (Inclusive of VAT)
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <TextField
                          label="Price (Inclusive)"
                          variant="outlined"
                          value={priceInclusive}
                          placeholder="Enter price"
                          type="text"
                          // onChange={(e) => {
                          //   const inputValue = e.target.value;

                          //   // Clear both fields if empty
                          //   if (inputValue === "") {
                          //     setpriceInclusive("");
                          //     setPriceExclusive(0);
                          //     setHasInclusiveValue(false);
                          //     return;
                          //   }

                          //   // Allow only valid decimal numbers
                          //   const regex = /^\d*\.?\d*$/;
                          //   if (!regex.test(inputValue)) return;

                          //   const inclusive = parseFloat(inputValue);
                          //   if (isNaN(inclusive) || inclusive <= 0) {
                          //     setHasInclusiveValue(false);
                          //     setpriceInclusive(inputValue);
                          //     return;
                          //   }

                          //   // Mark that we have a valid value
                          //   setHasInclusiveValue(true);

                          //   // Calculate exclusive price: Exclusive = Inclusive / (1 + VAT%)
                          //   let vatRate = 0;
                          //   if (radiovalue === "auto" && vatAdded?.percentage) {
                          //     vatRate = vatAdded.percentage / 100;
                          //   } else if (radiovalue === "Specify" && customVat) {
                          //     vatRate = parseFloat(customVat) / 100;
                          //   }
                          //   // If no VAT is set, treat as 0% → exclusive = inclusive
                          //   const exclusive = vatRate > 0 ? inclusive / (1 + vatRate) : inclusive;

                          //   setpriceInclusive(inputValue);
                          //   setPriceExclusive(exclusive);
                          // }}
                          // onKeyDown={(e) => {
                          //   if (["-", "e", "E"].includes(e.key)) {
                          //     e.preventDefault();
                          //   }
                          // }}
                          // inputProps={{
                          //   inputMode: "decimal",
                          // }}
                          // InputProps={{
                          //   endAdornment: (
                          //     <InputAdornment position="end">
                          //       <IconButton
                          //         aria-label="clear price"
                          //         onClick={() => {
                          //           setpriceInclusive("");
                          //           setPriceExclusive(0);
                          //           setHasInclusiveValue(false);
                          //         }}
                          //         edge="end"
                          //         size="small"
                          //         sx={{ color: "#999" }}
                          //       >
                          //         ❌
                          //       </IconButton>
                          //     </InputAdornment>
                          //   ),
                          // }}
                          fullWidth
                        />
                      </Grid>
                    </Grid>

                    {/* delivery section */}
                    <Grid
                      container
                      sx={{ padding: "0.5rem", marginBottom: "1rem" }}
                    >
                      <Grid item xs={12}>
                        <Typography
                          sx={{
                            paddingTop: "1rem",
                            marginBottom: "1rem",
                            marginRight: "2rem",
                          }}
                        >
                          Is Deliverable:
                        </Typography>

                        {sectionArray.map((sectionId) => {
                          // console.log("debug-section: ", sectionArray);

                          const sectionState = sectionStates[sectionId] || {};
                          // console.log("sectionState", sectionState);

                          const sectionInfo = sectionTitles[sectionId] || {
                            title: "Unknown Section",
                            isRestaurantCollectionOnly: false,
                          };
                          const sectionTitle = sectionInfo.title;
                          const isRestaurantCollectionOnly =
                            sectionInfo.isRestaurantCollectionOnly;

                          const sectionMenu = selectedMenuDatas.find(
                            (menu) =>
                              menu.id ===
                              selectedSectionDatas.find(
                                (section) => section.id === sectionId,
                              )?.menuId,
                          );

                          console.log("debug-123: ", sectionMenu);

                          const hasOnlyDine =
                            sectionMenu?.menuTypeName === "In-Store";

                          const hasOnlyDelivery =
                            sectionMenu?.menuTypeName === "Delivery";

                          const hasOnlyCollection =
                            sectionMenu.isCollectionOnly;

                          const hasDelivery =
                            sectionMenu?.menuTypeName?.includes("Delivery");

                          return (
                            <Grid
                              container
                              key={sectionId}
                              sx={{
                                marginBottom: "1rem",
                                marginLeft: "15rem",
                              }}
                            >
                              <Grid item xs={1.6}>
                                <Typography>{sectionTitle}:</Typography>
                              </Grid>
                              <Grid>
                                <Tooltip
                                  title={
                                    hasDelivery
                                      ? ""
                                      : "The Menu type is not Delivery"
                                  }
                                >
                                  <span>
                                    <Switch
                                      checked={
                                        hasOnlyDine
                                          ? false
                                          : sectionState.isDeliverable || false
                                      }
                                      onChange={(e) =>
                                        handleDeliverableCheck(
                                          sectionId,
                                          e.target.checked,
                                        )
                                      }
                                      inputProps={{
                                        "aria-label": "isDeliverable-toggle",
                                      }}
                                      disabled={
                                        hasOnlyDine ||
                                        hasOnlyDelivery ||
                                        !hasDelivery
                                      }
                                      // disabled={!hasDelivery}
                                    />
                                    {!hasDelivery && (
                                      <InfoOutlinedIcon
                                        color="action"
                                        sx={{ marginLeft: 1 }}
                                      />
                                    )}
                                  </span>
                                </Tooltip>
                              </Grid>

                              {/* Collection Only Toggle (Indented) */}
                              {!hasOnlyDine &&
                                (sectionState.isDeliverable ||
                                  hasOnlyDelivery) && (
                                  <Grid
                                    container
                                    sx={{
                                      marginLeft: "2rem",
                                      marginTop: "0.5rem",
                                    }}
                                  >
                                    <Grid item xs={2}>
                                      <Typography>Collection Only:</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                      <Switch
                                        checked={
                                          hasOnlyCollection ||
                                          sectionState.isCollection ||
                                          false
                                        }
                                        disabled={hasOnlyCollection}
                                        onChange={(e) => {
                                          handleCollectionCheck(
                                            sectionId,
                                            e.target.checked,
                                          );
                                        }}
                                        inputProps={{
                                          "aria-label":
                                            "isCollectionOnly-toggle",
                                        }}
                                        //disabled={isRestaurantCollectionOnly || hasOnlyDelivery}
                                        size="small"
                                      />
                                      {isRestaurantCollectionOnly && (
                                        <Tooltip title="Restaurant is collection only">
                                          <InfoOutlinedIcon
                                            color="action"
                                            sx={{ marginLeft: 1 }}
                                          />
                                        </Tooltip>
                                      )}
                                    </Grid>
                                  </Grid>
                                )}
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Grid>

                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography>Addons</Typography>
                      </Grid>
                      <Grid item xs={10}>
                        <Grid
                          container
                          sx={{ alignItems: "center" }}
                          spacing={3}
                        >
                          <Grid item xs={7}>
                            <AutoCompleteMultiSelect
                              id={88}
                              placeholder={"Add ons"}
                              datas={addOnDatas}
                              value={addonvalue}
                            />
                            {AddonsErr && (
                              <span style={{ color: "red" }}>
                                This field is required
                              </span>
                            )}
                          </Grid>
                          <Grid item xs={5}>
                            <Button onClick={handleOpen}>+Add addons</Button>
                            <Button onClick={handleopenImportSpecification}>
                              Import
                            </Button>
                          </Grid>
                        </Grid>

                        <ImportSpecification
                          open={openImportSpecification}
                          onClose={handleCloseImportSpecification}
                          onSave={handleAddSpecification}
                          onHandleAddItem={handleimportedDatas}
                        />
                        <AddSpecification
                          openFrom={"AddItemDialog"}
                          open={open}
                          onClose={handleCloseSpecifications}
                          onSave={handleAddSpecification}
                          dialogName={"Add Addons"}
                          reloadAddons={ReloadAddons}
                        />
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={9}>
                        {rowsData.length > 0 ? (
                          <TableContainer component={Paper}>
                            <Table aria-label="collapsible table">
                              <TableHead>
                                <TableRow>
                                  <TableCell />
                                  <TableCell>
                                    Must Pick
                                    <span> </span>
                                    <Switch
                                      checked={isMustPick}
                                      onChange={handleMustPick}
                                      size="small" // optional: makes the switch smaller
                                    />
                                  </TableCell>
                                  <TableCell>Rank</TableCell>
                                  <TableCell>AddOn Name</TableCell>
                                  <TableCell align="right">IsToggle</TableCell>
                                  <TableCell align="right">
                                    {" "}
                                    buttonStyle
                                  </TableCell>
                                  <TableCell align="right">
                                    maxSelection
                                  </TableCell>
                                  <TableCell>Link with fooditem</TableCell>
                                  <TableCell>Mandatory</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {rowsData.map((row, idx) => (
                                  <Row
                                    key={row.AddonName}
                                    row={row}
                                    idx={idx}
                                    onToggle={linktoggle}
                                    onMandatoryToggle={onMandatoryToggle}
                                  />
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        ) : (
                          ""
                        )}
                        {/* <StickyHeadTable rows={specificationRows} /> */}
                      </Grid>
                    </Grid>
                  </div>
                  <div className={`${value == "2" ? "d-block " : "d-none"} `}>
                    <Details
                      sendToAddItem={getDetailsdata}
                      openFrom={"AddItem"}
                    />
                  </div>
                  {/* )} */}
                  {/* {value === '3' && ( */}
                  <div className={`${value == "3" ? "d-block " : "d-none"} `}>
                    <Story sendStoryToAdditem={getStorydata} />
                  </div>
                  {/* )} */}
                  {/* {value == '4' && ( */}
                  <div className={`${value == "4" ? "d-block " : "d-none"} `}>
                    <Instructions
                      sendInstructionToAdditem={getInstructiondata}
                      openFrom={"AddItem"}
                    />
                  </div>

                  <div className={`${value == "5" ? "d-block " : "d-none"} `}>
                    <Kitchens
                      kitchens={kitchens}
                      getKitchens={getkitchensFnc}
                    />
                  </div>
                  {/* )} */}
                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Box sx={{ flex: "1 1 auto" }} />

                    <Button
                      //variant="outlined"
                      onClick={goToPreviousTab}
                      disabled={currentIndex === 0}
                    >
                      {currentIndex > 0 && `< ${tabs[currentIndex - 1].label}`}
                    </Button>

                    <Button
                      //variant="contained"
                      onClick={goToNextTab}
                      disabled={currentIndex === tabs.length - 1}
                    >
                      {currentIndex < tabs.length - 1 &&
                        `${tabs[currentIndex + 1].label} >`}
                    </Button>

                    <Button onClick={handleNext}>
                      {activeStep === steps.length - 1 ? "Finish" : "Next>>"}
                    </Button>
                  </Box>
                </React.Fragment>
              </div>
              {/* ) : (activeStep === 1 ? ( */}

              <div className={`${activeStep == 1 ? "d-block " : "d-none"} `}>
                <React.Fragment>
                  <AddItemSchedulerDialog
                    selectedSectionDatas={selectedSectionDatas}
                    // handleScheduleChange={handleScheduleChange}
                    prevScheduleSelecection={setSchedule}
                    handleInventorySave={handleInventorySave}
                  />

                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Box sx={{ flex: "1 1 auto" }} />
                    <Button
                      color="inherit"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mr: 1 }}
                    >
                      Back
                    </Button>
                    {activeStep === steps.length - 1 ? (
                      <Button onClick={onSave}>Save</Button>
                    ) : (
                      <Button onClick={handleNext}>Next</Button>
                    )}
                  </Box>
                </React.Fragment>
              </div>
            </DialogContent>
          </Dialog>
        </React.Fragment>
      </div>
      <AddSectionDialog
        open={openAddSection}
        dialogType={dialogType}
        onHandleAddItem={handleAddItem}
        menuList={Menudata}
      />
      {openAddKeyword ? (
        <KeywordDialog
          open={openAddKeyword}
          onHandleKeywordDialog={handleKeywordDialog}
        />
      ) : (
        ""
      )}
      <AddMenuDialog
        open={openMenu}
        dialogType={dialogType}
        onHandleAddItem={handleAddItem}
        onHandleSelectedData={handleAddMenuDialogData}
      />
      {/* <AddSectionDialog
        open={openAddSubSection}
        dialogType={dialogType}
        onHandleAddItem={handleAddItem}
        menuList={Menudata}
      /> */}

      <AddSubFilterDialog
        open={openAddSubSection}
        dialogType={dialogType}
        onHandleAddItem={handleAddItem}
        //menuList={Menudata}
      />

      <VatSetupDialog
        open={openAddVat}
        dialogType={dialogType}
        onHandleAddItem={handleAddItem}
        //menuList={Menudata}
      />
    </>
  );
}

export default AddItemDialogComponent;
